import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDroneManufacturer } from "../../redux/slice/instituteSlice";
import { Form, Spinner, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { companyCategory } from "../common/IndianStates";
import { Link } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import { useNavigate } from "react-router-dom";
import { handleLoginPopup } from "../../redux/slice/userSlice";
import Cookies from "js-cookie";
import axios from "axios";
import { Wallet, Briefcase } from "lucide-react";
import { motion } from "framer-motion";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import InfoIcon from "@mui/icons-material/Info"; // For Company/Organization Name
import BusinessIcon from "@mui/icons-material/Business"; // For Company Category
import WorkIcon from "@mui/icons-material/Work"; // For Product/Service
import LocationOnIcon from "@mui/icons-material/LocationOn"; // For Location
import LockIcon from "@mui/icons-material/Lock"; // For password labels
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // For valid password/confirm success
import CancelIcon from "@mui/icons-material/Cancel"; // For confirm password mismatch
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"; // For error messages
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BusinessIcon from "@mui/icons-material/Business";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// OTP Verification Component (shared across all forms)
import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";
import Navbar from "./Navbar";
import {Footer} from "../../shared";
import brand from "../../assets/image/png/brand.png";
import your from "../../assets/image/png/Your-Storefront.png";
import visibility from "../../assets/image/png/visibility.png";
import talent from "../../assets/image/png/talent-faster.png";
import sell from "../../assets/image/png/sell-directly.png";
import job from "../../assets/image/png/job-opening.png";
import { Avatar } from "@mui/material";
import { Header } from "../../shared";

// Register GSAP plugins
gsap.registerPlugin(TextPlugin);

const OtpVerify = ({ verifyOtp, resendOtp, onClose, phoneNumber, loading }) => {
  const [otp, setOtp] = useState("");
  const modalRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    // Animation for modal entrance
    gsap.fromTo(
      modalRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.3, ease: "power2.out" },
    );

    gsap.fromTo(
      contentRef.current,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.5, ease: "back.out(1.7)", delay: 0.2 },
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 4) {
      toast.error("Please enter a 4-digit OTP");
      return;
    }
    await verifyOtp(otp);
  };

  const handleInputHover = (e, isHover) => {
    gsap.to(e.target, {
      scale: isHover ? 1.05 : 1,
      boxShadow: isHover ? "0 5px 15px rgba(59, 130, 246, 0.4)" : "none",
      duration: 0.3,
      ease: "power1.out",
    });
  };

  const handleCloseHover = (isHover) => {
    gsap.to(".close-btn", {
      rotation: isHover ? 180 : 0,
      duration: 0.3,
      ease: "power1.out",
    });
  };

  return (
    <div
      ref={modalRef}
      className="relative z-10 mt-6" // ✅ inline, appears below where you render it
    >
      <div
        ref={contentRef}
        className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6 mx-auto animate-fadeIn"
      >
        <button
          onClick={onClose}
          onMouseEnter={() => handleCloseHover(true)}
          onMouseLeave={() => handleCloseHover(false)}
          className="close-btn absolute top-4 right-4 p-1 rounded-full hover:bg-gray-100 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">
            Verify your phone
          </h3>
          <p className="text-sm text-gray-500">
            Code sent to{" "}
            <span className="font-medium text-gray-700">{phoneNumber}</span>
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <div className="flex justify-center space-x-3">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  type="text"
                  value={otp[index] || ""}
                  onChange={(e) => {
                    const newOtp = [...otp];
                    newOtp[index] = e.target.value.replace(/\D/g, "");
                    setOtp(newOtp.join("").slice(0, 4));
                    // Auto focus to next input
                    if (e.target.value && index < 3) {
                      e.target.nextSibling?.focus();
                    }
                  }}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  maxLength={1}
                  className="otp-input w-14 h-14 text-2xl text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  pattern="\d*"
                  inputMode="numeric"
                />
              ))}
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || otp.length !== 4}
            onMouseEnter={(e) => {
              if (!(loading || otp.length !== 4)) {
                gsap.to(e.target, {
                  scale: 1.02,
                  boxShadow: "0 5px 15px rgba(59, 130, 246, 0.4)",
                  duration: 0.3,
                });
              }
            }}
            onMouseLeave={(e) => {
              if (!(loading || otp.length !== 4)) {
                gsap.to(e.target, {
                  scale: 1,
                  boxShadow: "none",
                  duration: 0.3,
                });
              }
            }}
            className={`verify-btn w-full py-3 px-4 rounded-lg font-medium text-white transition ${loading || otp.length !== 4 ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Verifying...
              </span>
            ) : (
              "Verify"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

// Main Multi-Form Component
const MultiFormRegistration = () => {
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("activeRegistrationTab");
    return savedTab || "drone";
  });
  const token = Cookies.get("token");

  const tabRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const formContainerRef = useRef(null);
  const heroIllustrationRef = useRef(null);

  useEffect(() => {
    localStorage.setItem("activeRegistrationTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    // Hero illustration animation
    gsap.fromTo(
      heroIllustrationRef.current,
      { scale: 0.8, opacity: 0, rotation: -5 },
      {
        scale: 1,
        opacity: 1,
        rotation: 0,
        duration: 1.2,
        ease: "elastic.out(1, 0.8)",
      },
    );

    // Title animation
    gsap.fromTo(
      titleRef.current,
      { y: -50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power3.out", delay: 0.3 },
    );

    // Subtitle animation
    gsap.fromTo(
      subtitleRef.current,
      { y: -30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power2.out", delay: 0.5 },
    );

    // Tab animation
    gsap.fromTo(
      tabRef.current,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "back.out(1.4)", delay: 0.7 },
    );

    // Form container animation
    gsap.fromTo(
      formContainerRef.current,
      { opacity: 0, scale: 0.95 },
      { opacity: 1, scale: 1, duration: 0.6, ease: "power2.out", delay: 0.9 },
    );
  }, []);

  const handleTabChange = (tab) => {
    // Animate tab change
    const activeButton = document.querySelector(
      `button[data-tab="${activeTab}"]`,
    );
    const newButton = document.querySelector(`button[data-tab="${tab}"]`);

    // Animate form container out
    gsap.to(formContainerRef.current, {
      opacity: 0,
      y: 20,
      duration: 0.3,
      onComplete: () => {
        setActiveTab(tab);
        // Animate form container back in
        setTimeout(() => {
          gsap.fromTo(
            formContainerRef.current,
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" },
          );
        }, 50);
      },
    });

    // Animate tab buttons
    gsap.to(activeButton, {
      scale: 0.95,
      opacity: 0.7,
      duration: 0.2,
      onComplete: () => {
        gsap.fromTo(
          newButton,
          { scale: 1.1, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.4, ease: "back.out(1.7)" },
        );
      },
    });
  };
  const tabBoxStyle = {
    display: "inline-flex",
    background: "rgba(255,255,255,0.8)",
    backdropFilter: "blur(6px)",
    padding: "6px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  };

  const tabBtnBase = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "8rem",
    minHeight: "70px",
    padding: "8px 16px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: 500,
    border: "1px solid #d1d5db",
    cursor: "pointer",
    transition: "all 0.3s ease",
    background: "white",
    margin: "0 4px",
    textAlign: "center",
    whiteSpace: "normal", // allow text wrapping
    wordWrap: "break-word",
  };

  const activeBtn = {
    background: "linear-gradient(to right, #3b82f6, #4f46e5)",
    color: "white",
    boxShadow: "0 6px 12px rgba(0,0,0,0.25)",
    transform: "scale(1.05)", // little zoom when active
  };

  const inactiveBtn = {
    color: "#374151",
  };

  const tabIconBase = {
    width: "20px",
    height: "20px",
    marginBottom: "4px",
    transition: "all 0.3s ease",
  };

  const tabDotStyle = {
    position: "absolute",
    bottom: "-4px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "6px",
    height: "6px",
    background: "#4f46e5",
    borderRadius: "50%",
    animation: "bounce 1s infinite",
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // empty dependency ensures it runs only once

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-100 py-12 px-4 relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute top-0 left-0 right-0 h-96 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 transform -skew-y-6 -translate-y-32"></div>

        <div className="max-w-6xl mx-auto relative z-10">
          {/* Hero Section */}
          <div className="flex flex-col lg:flex-row items-center justify-between mb-12 lg:mb-16">
            <div className="lg:w-1/2 mb-10 lg:mb-0">
              <h1
                ref={titleRef}
                className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight"
              >
                Join The{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                  Future
                </span>{" "}
                Of Drone Technology
              </h1>
              <p
                ref={subtitleRef}
                className="text-xl text-gray-700 mb-8 leading-relaxed"
              >
                Register your organization and become part of the premier
                ecosystem connecting manufacturers, service providers, and
                educators in the drone industry.
              </p>
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-1 text-blue-600">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Global Network</span>
                </div>
                <div className="flex items-center space-x-1 text-blue-600">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Industry Insights</span>
                </div>
                <div className="flex items-center space-x-1 text-blue-600">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Business Growth</span>
                </div>
              </div>
            </div>

            <div
              ref={heroIllustrationRef}
              className="lg:w-1/2 flex justify-center"
            >
              <div className="relative w-full max-w-md group">
                {/* Background Glows */}
                <div className="absolute -top-12 -left-12 w-40 h-40 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full blur-3xl opacity-40 animate-pulse"></div>
                <div className="absolute -bottom-12 -right-12 w-40 h-40 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full blur-3xl opacity-40 animate-pulse delay-2000"></div>

                {/* Card */}
                <div className="relative bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden transition-all duration-500 transform group-hover:scale-105 group-hover:shadow-2xl">
                  {/* Animated Top Bar */}
                  <div className="flex justify-center items-center gap-2 py-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-t-3xl">
                    <svg
                      className="w-8 h-8 animate-bounce"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      />
                    </svg>
                    <h3 className="text-lg font-semibold tracking-wide">
                      Drone Ecosystem
                    </h3>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    {/* Progress-style bars */}
                    <div className="grid grid-cols-3 gap-3 mb-8">
                      <div className="h-2 rounded-full bg-gradient-to-r from-blue-300 to-blue-500 animate-pulse"></div>
                      <div className="h-2 rounded-full bg-gradient-to-r from-indigo-300 to-indigo-500 animate-pulse delay-100"></div>
                      <div className="h-2 rounded-full bg-gradient-to-r from-purple-300 to-purple-500 animate-pulse delay-200"></div>
                      <div className="h-2 rounded-full bg-gradient-to-r from-blue-200 to-blue-400 animate-pulse delay-300"></div>
                      <div className="h-2 rounded-full bg-gradient-to-r from-indigo-200 to-indigo-400 animate-pulse delay-500"></div>
                      <div className="h-2 rounded-full bg-gradient-to-r from-purple-200 to-purple-400 animate-pulse delay-700"></div>
                    </div>

                    {/* Center Icon */}
                    <div className="flex justify-center mb-6">
                      <div className="relative w-28 h-28">
                        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 blur-lg opacity-40 animate-ping"></div>
                        <div className="relative w-28 h-28 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center shadow-lg transform group-hover:rotate-6 transition-transform duration-500">
                          <svg
                            className="w-14 h-14 text-white animate-fadeIn"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Text Content */}
                    <div className="text-center">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">
                        Seamless Registration
                      </h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Unlock access to the global{" "}
                        <span className="font-medium text-blue-600">
                          drone network
                        </span>
                        . From manufacturers to service providers — grow,
                        connect, and innovate with us.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Floating elements */}
                <div className="absolute -top-6 -right-6 w-14 h-14 bg-white rounded-xl shadow-lg flex items-center justify-center animate-float">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>

                <div className="absolute -bottom-6 -left-6 w-14 h-14 bg-white rounded-xl shadow-lg flex items-center justify-center animate-float delay-1000">
                  <svg
                    className="w-6 h-6 text-purple-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Tab Navigation */}
          <div ref={tabRef} className="flex justify-center mb-10">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "2.5rem",
              }}
            >
              <div style={tabBoxStyle}>
                {/* Drone Manufacture */}
                <button
                  onClick={() => handleTabChange("drone")}
                  style={{
                    ...tabBtnBase,
                    ...(activeTab === "drone" ? activeBtn : inactiveBtn),
                  }}
                >
                  <svg
                    style={{
                      ...tabIconBase,
                      color: activeTab === "drone" ? "white" : "#2563eb",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                    />
                  </svg>
                  <span>Drone Manufacturer</span>
                  {activeTab === "drone" && <div style={tabDotStyle}></div>}
                </button>

                {/* DAAS Services */}
                <button
                  onClick={() => handleTabChange("daas")}
                  style={{
                    ...tabBtnBase,
                    ...(activeTab === "daas" ? activeBtn : inactiveBtn),
                  }}
                >
                  <svg
                    style={{
                      ...tabIconBase,
                      color: activeTab === "daas" ? "white" : "#2563eb",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                  <span>DAAS Services</span>
                  {activeTab === "daas" && <div style={tabDotStyle}></div>}
                </button>

                {/* Institute */}
                <button
                  onClick={() => handleTabChange("institute")}
                  style={{
                    ...tabBtnBase,
                    ...(activeTab === "institute" ? activeBtn : inactiveBtn),
                  }}
                >
                  <svg
                    style={{
                      ...tabIconBase,
                      color: activeTab === "institute" ? "white" : "#2563eb",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 14l9-5-9-5-9 5 9 5z" />
                    <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                    />
                  </svg>
                  <span>Institute (RPTO)</span>
                  {activeTab === "institute" && <div style={tabDotStyle}></div>}
                </button>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div ref={formContainerRef}>
            {activeTab === "drone" && <DroneManufacturerForm />}
            {activeTab === "daas" && <DaasForm />}
            {activeTab === "institute" && <InstituteForm />}
          </div>
        </div>

        {/* Animated background elements */}
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
        <div className="absolute top-1/2 right-10 w-72 h-72 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-20 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>
      <Footer />

      <style jsx>{`
        @keyframes blob {
          0% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          100% {
            transform: translate(0px, 0px) scale(1);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </>
  );
};

// Individual Form Components
const DroneManufacturerForm = () => {
  const dispatch = useDispatch();
  const instituteData = useSelector((state) => state.institute);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkboxState, setCheckboxState] = useState({
    subsidyAcknowledgement: false,
  });
  const token = Cookies.get("token");
  const userId = Cookies.get("userId");
  const [isCheckingVerification, setIsCheckingVerification] = useState(true);
  const navigate = useNavigate();
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [checkingRegistration, setCheckingRegistration] = useState(true);
  const formRef = useRef(null);
  const successRef = useRef(null);
  const features = [
    {
      icon: sell,
      title: "Sell Directly to Thousands",
      desc: "Connect with ready-to-buy drone enthusiasts who are looking for exactly what you offer.",
    },
    {
      icon: job,
      title: "Post Job Openings",
      desc: "Hire Engineers, Technicians & Sales Pros FAST from our pool of qualified candidates.",
    },
    {
      icon: brand,
      title: "Showcase Your Brand",
      desc: "Your Drones. Your Parts. Your Prices. Complete control over your product listings.",
    },
    {
      icon: visibility,
      title: "Get Instant Visibility",
      desc: "Join a platform BUILT for Drone Businesses and get noticed immediately.",
    },
    {
      icon: your,
      title: "Your Storefront. Your Rules.",
      desc: "No Middlemen. No Delays. Just SALES. Full control over your profits.",
    },
    {
      icon: talent,
      title: "Find Talent Faster",
      desc: "Hire skilled experts in hardware, software, design, R&D, and more. Thousands of applicants. One platform.",
    },
  ];
  // Form data state
  const [formData, setFormData] = useState({
    name: "",
    modelNo: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    product: "",
    companyCategory: "",
  });

  // Password validation state
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: false,
    match: null,
  });

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  // const formRef = useRef<HTMLDivElement | null>(null)

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  // Check authentication and verification status on mount
  useEffect(() => {
    if (!token) {
      setIsCheckingVerification(false);
    } else {
      checkPhoneVerification();
    }
  }, [token, dispatch]);

  useEffect(() => {
    const checkRegistrationStatus = async () => {
      if (userId) {
        try {
          const response = await axios.get(
            process.env.REACT_APP_API_URL +
              `/checkManufacturerRegistration/${userId}`,
          );
          console.log(
            "Manufacturer registration check response:",
            response.data,
          );

          if (response.data.message === "Manufacturer found") {
            setAlreadyRegistered(true);
          }
        } catch (error) {
          console.error("Error checking registration status:", error);
        } finally {
          setCheckingRegistration(false);
        }
      } else {
        setCheckingRegistration(false);
      }
    };

    checkRegistrationStatus();
  }, [userId]);

  useEffect(() => {
    if (alreadyRegistered && successRef.current) {
      // Animate success message
      gsap.fromTo(
        successRef.current,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, ease: "elastic.out(1, 0.5)" },
      );

      // Animate checkmark
      gsap.fromTo(
        ".success-checkmark",
        { scale: 0, rotation: -180 },
        {
          scale: 1,
          rotation: 0,
          duration: 0.8,
          ease: "back.out(1.7)",
          delay: 0.3,
        },
      );
    }
  }, [alreadyRegistered]);

  useEffect(() => {
    if (formRef.current) {
      // Animate form elements sequentially
      gsap.fromTo(
        ".form-field",
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: "power2.out",
          delay: 0.3,
        },
      );
    }
  }, [phoneVerified, formRef]);

  // Check phone verification status
  const checkPhoneVerification = async () => {
    try {
      setIsCheckingVerification(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `/getInterstedData/${userId}`,
      );

      if (response.data.data) {
        setPhoneNumber(response.data.data.phoneNumber);

        if (response.data.data.verified) {
          setPhoneVerified(true);
          setFormData((prev) => ({
            ...prev,
            phoneNumber: response.data.data.phoneNumber,
            name: response.data.data.name || "",
            email: response.data.data.email || "",
            modelNo: response.data.data.companyName || "",
            product: response.data.data.product || "",
            companyCategory: response.data.data.companyCategory || "",
            address: response.data.data.address || "",
            password: "",
            confirmPassword: "",
          }));
        } else {
          setPhoneVerified(true);
        }
      }
    } catch (error) {
      console.error("Error checking phone verification:", error);
    } finally {
      setIsCheckingVerification(false);
    }
  };

  // Handle phone number submission
  const handlePhoneSubmit = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    if (!phoneNumber || phoneNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    setLoading(true);
    try {
      await axios.post(process.env.REACT_APP_API_URL + "/savePhone", {
        phoneNumber,
        type: "Manufacturer",
        userId,
      });

      setOtpLoading(true);
      const otpResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          phoneNumber,
          userId,
        },
      );

      if (otpResponse.data.status === "success") {
        toast.success(otpResponse.data.message || "OTP sent successfully");
        setShowModal(true);
      } else {
        toast.error(otpResponse.data.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to initiate verification",
      );
      console.error(error);
    } finally {
      setLoading(false);
      setOtpLoading(false);
    }
  };

  // Verify OTP
  const verifyOtp = async (otp) => {
    try {
      setOtpLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verifyOtp`,
        {
          phoneNumber,
          otp,
          userId,
        },
      );

      if (response.data.status === "success") {
        toast.success(
          response.data.message || "Phone number verified successfully",
        );
        setPhoneVerified(true);
        setFormData((prev) => ({ ...prev, phoneNumber }));
        setShowModal(false);

        // Store the active tab before reloading
        const activeTab =
          localStorage.getItem("activeRegistrationTab") || "drone";
        localStorage.setItem("activeRegistrationTab", activeTab);

        setTimeout(() => {
          window.location.reload();
        }, 1000);

        return true;
      } else {
        toast.error(response.data.message || "Invalid OTP");
        return false;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
      console.error(error);
      return false;
    } finally {
      setOtpLoading(false);
    }
  };

  // Resend OTP
  const resendOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/resendOtp`,
        {
          phoneNumber,
          userId,
        },
      );

      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP resent successfully");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
      console.error(error);
    } finally {
      setOtpLoading(false);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber" && !/^\d{0,10}$/.test(value)) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "password") {
      setPasswordValidation((prev) => ({
        ...prev,
        isValid: value.length >= 6,
      }));
    }

    if (name === "confirmPassword") {
      setPasswordValidation((prev) => ({
        ...prev,
        match: value === formData.password ? true : value ? false : null,
      }));
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxState({
      ...checkboxState,
      [name]: checked,
    });
  };

  // Handle form submission
  const submitHandle = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    // Create a complete submission object including verified phone number
    const submissionData = {
      ...formData,
      phoneNumber: phoneNumber || formData.phoneNumber,
      userId: userId,
    };

    // Check required fields
    const requiredFields = [
      "name",
      "modelNo",
      "phoneNumber",
      "email",
      "password",
      "address",
      "product",
      "companyCategory",
    ];

    const missingFields = requiredFields.filter(
      (field) => !submissionData[field],
    );

    if (missingFields.length > 0) {
      toast.error(`Missing required fields: ${missingFields.join(", ")}`);
      return;
    }

    if (!passwordValidation.isValid) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    if (passwordValidation.match === false) {
      toast.error("Password and confirm password don't match");
      return;
    }

    if (!checkboxState.subsidyAcknowledgement) {
      toast.error("Please accept the terms and conditions");
      return;
    }

    dispatch(
      addDroneManufacturer({
        formData: formData,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
      }),
    );

    sessionStorage.setItem("vendorData", JSON.stringify(formData));

    try {
      setLoading(true);
      // Call API directly instead of using Redux if that's causing issues
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/addEnlistDrone",
        submissionData,
      );

      if (response.data.status === "success") {
        toast.success(response.data.message);
        // Redirect or perform next steps
        navigate("/mou");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Submission failed");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle location selection
  const handlePlaceSelected = (place) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      address: place.formatted_address,
      location: [place.geometry.location.lat(), place.geometry.location.lng()],
    }));
  };

  // Close modal
  const onCloseModal = () => {
    setShowModal(false);
  };
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };
  // Handle input hover effects
  const handleInputHover = (e, isHover) => {
    gsap.to(e.target, {
      y: isHover ? -2 : 0,
      boxShadow: isHover ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
      duration: 0.3,
      ease: "power1.out",
    });
  };

  // Handle button hover effects
  const handleButtonHover = (e, isHover) => {
    gsap.to(e.target, {
      scale: isHover ? 1.02 : 1,
      boxShadow: isHover ? "0 5px 15px rgba(59, 130, 246, 0.4)" : "none",
      duration: 0.3,
    });
  };

  // Loading state
  if (isCheckingVerification) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (alreadyRegistered) {
    return (
      <div
        id="success-message"
        ref={successRef}
        className="flex justify-center items-center min-h-screen py-8 px-4"
        style={{ paddingTop: "700px" }}
      >
        <div className="flex justify-center items-center min-h-[60vh] bg-gradient-to-br from-green-50 to-white px-4">
          <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl max-w-md w-full text-center">
            <div className="flex justify-center mb-4">
              <div className="success-checkmark bg-green-100 p-4 rounded-full shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 text-green-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              Manufacturer Registration Successful!
            </h2>
            <p className="text-base text-gray-600 mb-1">
              Your manufacturer account has been registered successfully.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Thank you for joining{" "}
              <span className="font-medium text-green-600">Drone Planet</span>.
            </p>
            <div className="flex justify-center gap-4">
              <Link
                to="/"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition transform hover:scale-105"
              >
                Go to Home
              </Link>
              <a
                href="mailto:manufacturer-support@droneplanet.in"
                className="px-4 py-2 text-sm border border-blue-600 text-blue-600 rounded hover:bg-blue-50 transition"
              >
                Manufacturer Support
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Unauthenticated users
  if (!token) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 relative overflow-hidden">
          {/* Background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
            <div className="absolute top-40 right-10 w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
          </div>

          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 space-y-12 relative z-10">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="flex flex-col items-center text-center space-y-6"
            >
              <div className="relative">
                <div className="absolute -inset-4 bg-blue-600 opacity-20 blur-lg rounded-full"></div>
                <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight relative">
                  Welcome to{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                    DronePlanet
                  </span>
                  <br />
                  <span className="text-xl md:text-2xl font-semibold text-gray-600 mt-3 block">
                    Where Innovation Takes Flight!
                  </span>
                </h1>
              </div>

              <p className="text-lg text-gray-700 max-w-2xl bg-white/70 backdrop-blur-sm p-5 rounded-2xl shadow-sm border border-white">
                Are you a Drone Manufacturer? Stop Waiting. Start Selling. Start
                Hiring. Join the{" "}
                <span className="font-semibold text-blue-700">
                  #1 Explosive Marketplace
                </span>{" "}
                for Drones, Parts & Talents.
              </p>

              {/* 🚀 CTA Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Why Register Section */}
            <section className="relative py-16">
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
                Why Register on{" "}
                <span className="text-blue-600">DronePlanet</span>?
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-0">
                {features.map((card, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1, duration: 0.6 }}
                    whileHover={{ y: -6, transition: { duration: 0.2 } }}
                    className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-white relative overflow-hidden group"
                  >
                    {/* Top gradient line */}
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-indigo-500"></div>

                    {/* Icon */}
                    <div className="mb-5 w-14 h-14">
                      <img
                        src={card.icon}
                        alt={card.title}
                        className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>

                    {/* Title & Description */}
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {card.title}
                    </h3>
                    <p className="text-gray-600 text-sm">{card.desc}</p>

                    {/* Background SVG */}
                    <div className="absolute bottom-0 right-0 w-14 h-14 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                      <svg
                        viewBox="0 0 24 24"
                        className="w-14 h-14 text-blue-500"
                        fill="currentColor"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                    </div>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Who's It For Section */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
                Who's It For?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {[
                  "Drone & UAV Manufacturers",
                  "Drone Part & Component Makers",
                  "Custom Drone Builders",
                  "Startups in Drone Tech",
                  "Aerospace Innovators",
                  "Anyone Building the Future of Flight",
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1 }}
                    whileHover={{ y: -4, scale: 1.02 }}
                    className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-white/50 group"
                  >
                    <div className="flex items-center">
                      <div className="flex-shrink-0 w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors duration-300">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <span className="text-gray-800 text-sm font-medium">
                        {item}
                      </span>
                    </div>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Closing CTA Section */}
            <motion.section
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-center space-y-6 py-8 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 rounded-2xl backdrop-blur-sm border border-white/30"
            >
              <div className="max-w-3xl mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  You're a manufacturer – you build the future. Let the world
                  see it.
                </h2>
                <p className="text-gray-700 text-base mb-5">
                  From cutting-edge drones to essential components, DronePlanet
                  is where your products get the attention and orders they
                  deserve.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <motion.a
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    href="https://wa.me/919773571992"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-3 px-6 rounded-full font-medium shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    Contact Sales
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </motion.a>
                </div>
              </div>
            </motion.section>
          </div>
        </div>

        <div ref={formRef} className="w-full max-w-md mx-auto">
          <div className="text-center mb-10">
            <h4 className="text-3xl font-bold text-gray-800">
              Enlist your{" "}
              <span className="text-blue-600">Company/Organisation</span>
            </h4>
            <p className="mt-2 text-gray-600">
              Please login to verify your phone number
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Number <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                maxLength="10"
                placeholder="Enter 10-digit phone number"
                onFocus={(e) => handleInputHover(e, true)}
                onBlur={(e) => handleInputHover(e, false)}
              />
            </div>

            <button
              onClick={handlePhoneSubmit}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
              className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-lg hover:shadow-md transition-all duration-300 hover:from-blue-700 hover:to-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Verify Phone Number
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Authenticated users - phone verification needed
  const shouldShowForm = phoneVerified || instituteData?.data?.phoneNumber;

  if (!shouldShowForm) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 relative overflow-hidden">
          {/* Background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
            <div className="absolute top-40 right-10 w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
          </div>

          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 space-y-12 relative z-10">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="flex flex-col items-center text-center space-y-6"
            >
              <div className="relative">
                <div className="absolute -inset-4 bg-blue-600 opacity-20 blur-lg rounded-full"></div>
                <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight relative">
                  Welcome to{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                    DronePlanet
                  </span>
                  <br />
                  <span className="text-xl md:text-2xl font-semibold text-gray-600 mt-3 block">
                    Where Innovation Takes Flight!
                  </span>
                </h1>
              </div>

              <p className="text-lg text-gray-700 max-w-2xl bg-white/70 backdrop-blur-sm p-5 rounded-2xl shadow-sm border border-white">
                Are you a Drone Manufacturer? Stop Waiting. Start Selling. Start
                Hiring. Join the{" "}
                <span className="font-semibold text-blue-700">
                  #1 Explosive Marketplace
                </span>{" "}
                for Drones, Parts & Talents.
              </p>

              {/* 🚀 CTA Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Why Register Section */}
            <section className="relative py-16">
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
                Why Register on{" "}
                <span className="text-blue-600">DronePlanet</span>?
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-0">
                {features.map((card, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1, duration: 0.6 }}
                    whileHover={{ y: -6, transition: { duration: 0.2 } }}
                    className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-white relative overflow-hidden group"
                  >
                    {/* Top gradient line */}
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-indigo-500"></div>

                    {/* Icon */}
                    <div className="mb-5 w-14 h-14">
                      <img
                        src={card.icon}
                        alt={card.title}
                        className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>

                    {/* Title & Description */}
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {card.title}
                    </h3>
                    <p className="text-gray-600 text-sm">{card.desc}</p>

                    {/* Background SVG */}
                    <div className="absolute bottom-0 right-0 w-14 h-14 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                      <svg
                        viewBox="0 0 24 24"
                        className="w-14 h-14 text-blue-500"
                        fill="currentColor"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                    </div>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Who's It For Section */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
                Who's It For?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {[
                  "Drone & UAV Manufacturers",
                  "Drone Part & Component Makers",
                  "Custom Drone Builders",
                  "Startups in Drone Tech",
                  "Aerospace Innovators",
                  "Anyone Building the Future of Flight",
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1 }}
                    whileHover={{ y: -4, scale: 1.02 }}
                    className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-white/50 group"
                  >
                    <div className="flex items-center">
                      <div className="flex-shrink-0 w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors duration-300">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <span className="text-gray-800 text-sm font-medium">
                        {item}
                      </span>
                    </div>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Closing CTA Section */}
            <motion.section
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-center space-y-6 py-8 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 rounded-2xl backdrop-blur-sm border border-white/30"
            >
              <div className="max-w-3xl mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  You're a manufacturer – you build the future. Let the world
                  see it.
                </h2>
                <p className="text-gray-700 text-base mb-5">
                  From cutting-edge drones to essential components, DronePlanet
                  is where your products get the attention and orders they
                  deserve.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <motion.a
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    href="https://wa.me/919773571992"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-3 px-6 rounded-full font-medium shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    Contact Sales
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </motion.a>
                </div>
              </div>
            </motion.section>
          </div>
        </div>

        {/* Wrapper for Centering */}
        <div className="flex items-center justify-center min-h-screen px-4 from-blue-50 to-indigo-100">
          <div
            ref={formRef}
            className="w-full max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden relative"
          >
            {/* Header */}
            <div className="bg-blue-600 px-6 py-8 text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 bg-white rounded-full mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Register Your Company/Organization
              </h1>
              <p className="text-blue-100">
                Complete your registration in just 2 simple steps
              </p>
            </div>

            {/* Steps */}
            <div className="flex justify-center px-8 pt-6">
              <div className="w-full max-w-md">
                <div className="flex items-center">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">
                      1
                    </div>
                    <div className="text-sm font-medium text-blue-600 mt-1">
                      Phone Verification
                    </div>
                  </div>
                  <div className="flex-1 h-1 bg-gray-200 mx-2"></div>
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center font-bold">
                      2
                    </div>
                    <div className="text-sm font-medium text-gray-500 mt-1">
                      Company Details
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="px-6 py-8 sm:px-10">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-gray-800">
                  Verify Your Phone Number
                </h2>
                <p className="text-gray-600 mt-2">
                  We'll send a 4-digit verification code
                </p>
              </div>

              <div className="max-w-md mx-auto space-y-6">
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span className="text-gray-500 sm:text-sm">+91</span>
                    </div>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={phoneNumber}
                      onChange={(e) =>
                        setPhoneNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10),
                        )
                      }
                      maxLength="10"
                      className="block w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                      placeholder=""
                      inputMode="numeric"
                      onFocus={(e) => handleInputHover(e, true)}
                      onBlur={(e) => handleInputHover(e, false)}
                    />
                  </div>
                </div>

                <div className="pt-2">
                  <button
                    onClick={handlePhoneSubmit}
                    disabled={loading || phoneNumber.length !== 10}
                    onMouseEnter={(e) => {
                      if (!(loading || phoneNumber.length !== 10)) {
                        handleButtonHover(e, true);
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!(loading || phoneNumber.length !== 10)) {
                        handleButtonHover(e, false);
                      }
                    }}
                    className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                      loading || phoneNumber.length !== 10
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    {loading ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Sending OTP...
                      </>
                    ) : (
                      "Send Verification Code"
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* OTP Popup */}
            {showModal && (
              <div className="absolute inset-0 z-50 flex items-start justify-center bg-white/70 backdrop-blur-sm rounded-xl">
                <div className="mt-32 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
                  <OtpVerify
                    verifyOtp={verifyOtp}
                    resendOtp={resendOtp}
                    onClose={onCloseModal}
                    phoneNumber={phoneNumber}
                    loading={otpLoading}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Full form for verified users
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Marketing Header Section */}
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 relative overflow-hidden">
          {/* Background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
            <div className="absolute top-40 right-10 w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
          </div>

          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 space-y-12 relative z-10">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="flex flex-col items-center text-center space-y-6"
            >
              <div className="relative">
                <div className="absolute -inset-4 bg-blue-600 opacity-20 blur-lg rounded-full"></div>
                <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight relative">
                  Welcome to{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                    DronePlanet
                  </span>
                  <br />
                  <span className="text-xl md:text-2xl font-semibold text-gray-600 mt-3 block">
                    Where Innovation Takes Flight!
                  </span>
                </h1>
              </div>

              <p className="text-lg text-gray-700 max-w-2xl bg-white/70 backdrop-blur-sm p-5 rounded-2xl shadow-sm border border-white">
                Are you a Drone Manufacturer? Stop Waiting. Start Selling. Start
                Hiring. Join the{" "}
                <span className="font-semibold text-blue-700">
                  #1 Explosive Marketplace
                </span>{" "}
                for Drones, Parts & Talents.
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Why Register Section */}
            <section className="relative py-16">
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
                Why Register on{" "}
                <span className="text-blue-600">DronePlanet</span>?
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-0">
                {features.map((card, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1, duration: 0.6 }}
                    whileHover={{ y: -6, transition: { duration: 0.2 } }}
                    className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-white relative overflow-hidden group"
                  >
                    {/* Top gradient line */}
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-indigo-500"></div>

                    {/* Icon */}
                    <div className="mb-5 w-14 h-14">
                      <img
                        src={card.icon}
                        alt={card.title}
                        className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>

                    {/* Title & Description */}
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {card.title}
                    </h3>
                    <p className="text-gray-600 text-sm">{card.desc}</p>

                    {/* Background SVG */}
                    <div className="absolute bottom-0 right-0 w-14 h-14 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                      <svg
                        viewBox="0 0 24 24"
                        className="w-14 h-14 text-blue-500"
                        fill="currentColor"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                    </div>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Who's It For Section */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
                Who's It For?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {[
                  "Drone & UAV Manufacturers",
                  "Drone Part & Component Makers",
                  "Custom Drone Builders",
                  "Startups in Drone Tech",
                  "Aerospace Innovators",
                  "Anyone Building the Future of Flight",
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1 }}
                    whileHover={{ y: -4, scale: 1.02 }}
                    className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-white/50 group"
                  >
                    <div className="flex items-center">
                      <div className="flex-shrink-0 w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors duration-300">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <span className="text-gray-800 text-sm font-medium">
                        {item}
                      </span>
                    </div>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Closing CTA Section */}
            <motion.section
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-center space-y-6 py-8 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 rounded-2xl backdrop-blur-sm border border-white/30"
            >
              <div className="max-w-3xl mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  You're a manufacturer – you build the future. Let the world
                  see it.
                </h2>
                <p className="text-gray-700 text-base mb-5">
                  From cutting-edge drones to essential components, DronePlanet
                  is where your products get the attention and orders they
                  deserve.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <motion.a
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    href="https://wa.me/919773571992"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-3 px-6 rounded-full font-medium shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    Contact Sales
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </motion.a>
                </div>
              </div>
            </motion.section>
          </div>
        </div>

        <div ref={formRef} className="text-center mb-10">
          <h1 className="text-2xl font-bold text-gray-800 mb-3">
            Register Your{" "}
            <span className="text-blue-600">Drone Manufacturing Company</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join our network of certified drone manufacturers and showcase your
            products to potential buyers worldwide.
          </p>
        </div>

        <div
          ref={formRef}
          className="bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          {/* Progress Bar */}
          <div className="bg-gray-100 px-6 py-4">
            <div className="flex items-center">
              <div className="flex-1">
                <div className="text-sm font-medium text-gray-700">
                  Registration Progress
                </div>
                <div className="mt-1 flex items-center">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all duration-500"
                      style={{ width: "50%" }}
                    ></div>
                  </div>
                  <span className="ml-4 text-xs font-medium text-gray-600">
                    50%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Contact Information Section */}
              <div className="md:col-span-2 mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <Avatar
                      // replace with your image path
                      alt="Contact Icon"
                      // sx={{ bgcolor: "blue.100", width: 32, height: 32 }}
                    />
                  </span>
                  Contact Information
                </h2>
              </div>

              {/* Name Field */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="name"
                >
                  <PersonIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Name of Contact Person
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Enter full name"
                />
              </div>

              {/* Email Field */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="email"
                >
                  <EmailIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Email <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="company@example.com"
                />
              </div>

              {/* Company Information Section */}
              <div className="md:col-span-2 mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1极速飞艇m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1极速飞艇v5m-4 0h4"
                      />
                    </svg>
                  </span>
                  Company Information
                </h2>
              </div>

              {/* Company Name */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="modelNo"
                >
                  <InfoIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Company/Organization Name
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="modelNo"
                  value={formData.modelNo}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Your company name"
                />
              </div>

              {/* Company Category */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="companyCategory"
                >
                  <BusinessIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Company Category
                </label>
                <div className="relative">
                  <Form.Select
                    name="companyCategory"
                    value={formData.companyCategory}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all appearance-none"
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                  >
                    <option value="">Select Category</option>
                    {companyCategory.map((value, index) => (
                      <option key={index} value={value}>
                        {value}
                      </option>
                    ))}
                  </Form.Select>
                  {/* You can keep dropdown arrow SVG or replace with MUI ExpandMore */}
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    {/* import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; */}
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Product/Service */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="product"
                >
                  <WorkIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Product/Service
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="product"
                  value={formData.product}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="e.g., Agricultural drones, Surveillance drones"
                />
              </div>

              {/* Location */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="location"
                >
                  <LocationOnIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Location <span className="text-red-500 ml-1">*</span>
                </label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_KEY}
                  onPlaceSelected={handlePlaceSelected}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  options={{
                    types: ["(cities)"],
                    componentRestrictions: { country: "in" },
                  }}
                  placeholder="Enter your city"
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                />
              </div>

              {/* Security Section */}
              <div className="md:col-span-2 mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </span>
                  Account Security
                </h2>
              </div>

              {/* Password */}
              {/* Password */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="password"
                >
                  <LockIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Password <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    className={`w-full px-4 py-3 rounded-lg border ${
                      passwordValidation.isValid
                        ? "border-green-500"
                        : "border-red-500"
                    } focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10`}
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                    placeholder="Create a strong password"
                  />
                  {passwordValidation.isValid ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CheckCircleIcon className="text-green-500" />
                    </div>
                  ) : (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <LockIcon
                        className="text-gray-500"
                        sx={{ fontSize: 18 }}
                      />
                    </div>
                  )}
                </div>
                {!passwordValidation.isValid && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <ErrorOutlineIcon className="h-4 w-4 mr-1" />
                    Password must be at least 6 characters long
                  </p>
                )}
              </div>

              {/* Confirm Password */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="confirmPassword"
                >
                  <LockIcon
                    className="text-gray-500 mr-1"
                    sx={{ fontSize: 16 }}
                  />
                  Confirm Password <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    className={`w-full px-4 py-3 rounded-lg border ${
                      passwordValidation.match === true
                        ? "border-green-500"
                        : passwordValidation.match === false
                          ? "border-red-500"
                          : "border-gray-300"
                    } focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10`}
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                    placeholder="Confirm your password"
                  />
                  {passwordValidation.match === true ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CheckCircleIcon className="text-green-500" />
                    </div>
                  ) : passwordValidation.match === false ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CancelIcon className="text-red-500" />
                    </div>
                  ) : null}
                </div>

                {passwordValidation.match === false && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <ErrorOutlineIcon className="h-4 w-4 mr-1" />
                    Passwords do not match
                  </p>
                )}
                {passwordValidation.match === true && (
                  <p className="mt-2 text-sm text-green-600 flex items-center">
                    <CheckCircleIcon className="h-4 w-4 mr-1" />
                    Passwords match
                  </p>
                )}
              </div>
            </div>

            {/* Terms and Conditions */}
            <div className="flex items-start mt-8 form-field p-4 bg-blue-50 rounded-lg">
              <div className="flex items-center h-5">
                <input
                  type="checkbox"
                  id="subsidyAcknowledgement"
                  name="subsidyAcknowledgement"
                  checked={checkboxState.subsidyAcknowledgement}
                  onChange={handleCheckboxChange}
                  className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
              </div>
              <div className="ml-3 text-sm">
                <label
                  htmlFor="subsidyAcknowledgement"
                  className="font-medium text-gray-700"
                >
                  I Accept The{" "}
                  <Link
                    to="/terms-and-conditions"
                    className="text-blue-600 hover:text-blue-500 underline font-semibold"
                  >
                    Terms and Conditions
                  </Link>{" "}
                  and acknowledge that I have read the{" "}
                  <Link
                    to="/privacy-policy"
                    className="text-blue-600 hover:text-blue-500 underline font-semibold"
                  >
                    Privacy Policy
                  </Link>
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <button
              onClick={submitHandle}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
              className="w-full mt-6 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-md hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 flex justify-center items-center gap-2"
            >
              {instituteData.loading ? (
                <>
                  <Spinner animation="border" size="sm" />
                  <span className="text-sm">Processing...</span>
                </>
              ) : (
                <>
                  <span className="text-sm">Validate and Proceed</span>
                  <svg
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
// Add CSS for animations
const styles = `
  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
  }
  
  .float-animation {
    animation: float 3s ease-in-out infinite;
  }
  
  .form-field input:focus, .form-field select:focus {
    transform: translateY(-2px);
    transition: all 0.3s ease;
  }
  
  .tab-btn {
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  }
  
  .verify-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  }
  
  .otp-input {
    transition: all 0.3s ease;
  }
  
  .otp-input:focus {
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);
  }
  
  .submit-btn {
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  }
  
  .success-checkmark {
    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  }
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

// DAAS Form Component
const DaasForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const userId = Cookies.get("userId");
  const formRef = useRef(null);
  const successRef = useRef(null);

  // Verification states
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCheckingVerification, setIsCheckingVerification] = useState(true);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [checkingRegistration, setCheckingRegistration] = useState(true);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("enterprises");
  // Form data state
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    location: "",
    userType: "individual",
    companyName: "",
    companyAddress: "",
  });

  // Password validation state
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: false,
    match: null,
  });

  // Checkboxes
  const [checkboxState, setCheckboxState] = useState({
    subsidyAcknowledgement: false,
  });

  // Animation effects
  useEffect(() => {
    if (alreadyRegistered && successRef.current) {
      // Animate success message
      gsap.fromTo(
        successRef.current,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, ease: "elastic.out(1, 0.5)" },
      );

      // Animate checkmark
      gsap.fromTo(
        ".success-checkmark",
        { scale: 0, rotation: -180 },
        {
          scale: 1,
          rotation: 0,
          duration: 0.8,
          ease: "back.out(1.7)",
          delay: 0.3,
        },
      );
    }
  }, [alreadyRegistered]);

  useEffect(() => {
    if (formRef.current) {
      // Animate form elements sequentially
      gsap.fromTo(
        ".form-field",
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: "power2.out",
          delay: 0.3,
        },
      );
    }
  }, [phoneVerified, formRef]);

  // Check authentication and verification status on mount
  useEffect(() => {
    if (!token) {
      setIsCheckingVerification(false);
    } else {
      checkPhoneVerification();
    }
  }, [token, dispatch]);

  // Check registration status
  useEffect(() => {
    const checkRegistrationStatus = async () => {
      if (userId) {
        try {
          const response = await axios.get(
            process.env.REACT_APP_API_URL + `/checkDAASRegistration/${userId}`,
          );
          console.log("Registration check response:", response.data);

          // Check for both response formats
          if (
            response.data.registered === true ||
            response.data.message === "DAAS Vendor found"
          ) {
            setAlreadyRegistered(true);
          }
        } catch (error) {
          console.error("Error checking registration status:", error);
        } finally {
          setCheckingRegistration(false);
        }
      } else {
        setCheckingRegistration(false);
      }
    };

    checkRegistrationStatus();
  }, [userId]);

  // Check phone verification status
  const checkPhoneVerification = async () => {
    try {
      setIsCheckingVerification(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `/getInterstedData/${userId}`,
      );
      console.log("Verification check response:", response.data);

      if (response.data.data) {
        setPhoneNumber(response.data.data.phoneNumber);

        if (response.data.data.verified) {
          setPhoneVerified(true);
          setFormData((prev) => ({
            ...prev,
            phoneNumber: response.data.data.phoneNumber,
            name: response.data.data.name || "",
            email: response.data.data.email || "",
            address: response.data.data.address || "",
            location: response.data.data.location || "",
            companyName: response.data.data.companyName || "",
            companyAddress: response.data.data.companyAddress || "",
            password: "",
            confirmPassword: "",
          }));
        } else {
          setPhoneVerified(true);
        }
      }
    } catch (error) {
      console.error("Error checking phone verification:", error);
    } finally {
      setIsCheckingVerification(false);
    }
  };

  // Handle input hover effects
  const handleInputHover = (e, isHover) => {
    gsap.to(e.target, {
      y: isHover ? -2 : 0,
      boxShadow: isHover ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
      duration: 0.3,
      ease: "power1.out",
    });
  };

  // Handle button hover effects
  const handleButtonHover = (e, isHover) => {
    gsap.to(e.target, {
      scale: isHover ? 1.02 : 1,
      boxShadow: isHover ? "0 5px 15px rgba(59, 130, 246, 0.4)" : "none",
      duration: 0.3,
    });
  };

  // Handle phone number submission
  const handlePhoneSubmit = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    if (!phoneNumber || phoneNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    setLoading(true);
    try {
      await axios.post(process.env.REACT_APP_API_URL + "/savePhone", {
        phoneNumber,
        type: "daasVendor",
        userId,
      });

      setOtpLoading(true);
      const otpResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          phoneNumber,
          userId,
        },
      );

      if (otpResponse.data.status === "success") {
        toast.success(otpResponse.data.message || "OTP sent successfully");
        setShowModal(true);
      } else {
        toast.error(otpResponse.data.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to initiate verification",
      );
      console.error(error);
    } finally {
      setLoading(false);
      setOtpLoading(false);
    }
  };

  // Verify OTP
  const verifyOtp = async (otp) => {
    try {
      setOtpLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verifyOtp`,
        {
          phoneNumber,
          otp,
          userId,
        },
      );

      if (response.data.status === "success") {
        toast.success(
          response.data.message || "Phone number verified successfully",
        );
        setPhoneVerified(true);
        setFormData((prev) => ({ ...prev, phoneNumber }));
        setShowModal(false);

        // Store the active tab before reloading
        const activeTab =
          localStorage.getItem("activeRegistrationTab") || "drone";
        localStorage.setItem("activeRegistrationTab", activeTab);

        setTimeout(() => {
          window.location.reload();
        }, 1000);

        return true;
      } else {
        toast.error(response.data.message || "Invalid OTP");
        return false;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
      console.error(error);
      return false;
    } finally {
      setOtpLoading(false);
    }
  };

  // Resend OTP
  const resendOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/resendOtp`,
        {
          phoneNumber,
          userId,
        },
      );

      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP resent successfully");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
      console.error(error);
    } finally {
      setOtpLoading(false);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber" && !/^\d{0,10}$/.test(value)) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "password") {
      setPasswordValidation((prev) => ({
        ...prev,
        isValid: value.length >= 6,
      }));
    }

    if (name === "confirmPassword") {
      setPasswordValidation((prev) => ({
        ...prev,
        match: value === formData.password ? true : value ? false : null,
      }));
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxState({
      ...checkboxState,
      [name]: checked,
    });
  };

  // Handle form submission
  const submitHandle = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    // Create submission data
    const submissionData = {
      ...formData,
      phoneNumber: phoneNumber || formData.phoneNumber,
      userId,
    };

    // Validate required fields
    const requiredFields = [
      "name",
      "phoneNumber",
      "email",
      "password",
      "address",
      "location",
      "userType",
    ];

    if (formData.userType === "company") {
      requiredFields.push("companyName", "companyAddress");
    }

    const missingFields = requiredFields.filter(
      (field) => !submissionData[field],
    );

    if (missingFields.length > 0) {
      toast.error(`Missing required fields: ${missingFields.join(", ")}`);
      return;
    }

    if (!passwordValidation.isValid) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    if (passwordValidation.match === false) {
      toast.error("Passwords don't match");
      return;
    }

    if (!checkboxState.subsidyAcknowledgement) {
      toast.error("Please accept the terms and conditions");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/addDAASVendor`,
        submissionData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.status === "success") {
        toast.success(
          response.data.message || "Vendor registration successful!",
        );
        setAlreadyRegistered(true);
        if (response.data.status === "success") {
          window.location.reload();
        }
      } else {
        toast.error(response.data.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(
        error.response?.data?.message ||
          "Vendor registration failed. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle location selection
  const handlePlaceSelected = (place) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      location: [
        place.geometry.location.lat(),
        place.geometry.location.lng(),
      ].join(","),
    }));
  };

  // Close modal
  const onCloseModal = () => {
    setShowModal(false);
  };

  // Loading state
  if (isCheckingVerification) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (alreadyRegistered) {
    return (
      <div
        id="success-message"
        ref={successRef}
        className="flex justify-center items-center min-h-screen py-8 px-4"
        style={{ paddingTop: "700px" }}
      >
        <div className="flex justify-center items-center min-h-[60vh] bg-gradient-to-br from-green-50 to-white px-4">
          <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl max-w-md w-full text-center">
            <div className="flex justify-center mb-4">
              <div className="success-checkmark bg-green-100 p-4 rounded-full shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 text-green-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              DaaS Vendor Registration Successful!
            </h2>
            <p className="text-base text-gray-600 mb-1">
              Your DaaS vendor account has been registered successfully.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Thank you for joining{" "}
              <span className="font-medium text-green-600">Drone Planet</span>.
            </p>
            <div className="flex justify-center gap-4">
              <Link
                to="/"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition transform hover:scale-105"
              >
                Go to Home
              </Link>
              <a
                href="mailto:vendor-support@droneplanet.in"
                className="px-4 py-2 text-sm border border-blue-600 text-blue-600 rounded hover:bg-blue-50 transition"
              >
                Vendor Support
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Unauthenticated users
  if (!token) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 space-y-10">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="flex flex-col items-center text-center"
            >
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
                On-Demand <span className="text-blue-600">Drone Services</span>{" "}
                Across India
              </h1>
              <p className="text-base md:text-lg text-gray-600 max-w-2xl mb-6">
                Connect with{" "}
                <span className="font-semibold">
                  DGCA-Certified Drone Pilots
                </span>
                & Fleet Operators. From agriculture to inspections and events –
                DronePlanet is your trusted Drone-as-a-Service (DaaS)
                marketplace.
              </p>

              {/* Custom Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Services Section */}
            <section>
              <div className="text-center mb-8">
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="text-2xl sm:text-3xl font-bold text-gray-800"
                >
                  Our Reach & Services
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  className="text-gray-600 mt-2 text-base md:text-lg"
                >
                  Delivering drone-powered solutions across industries and
                  geographies
                </motion.p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Services Offered */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white shadow-md rounded-xl p-6 transition-transform"
                >
                  <h3 className="text-xl font-semibold text-green-700 mb-4">
                    Services We Offer
                  </h3>
                  <ul className="space-y-2 text-gray-700 text-base">
                    <li className="flex items-center gap-2">
                      🚜 Agricultural Survey
                    </li>
                    <li className="flex items-center gap-2">
                      🏗️ Infrastructure Inspection
                    </li>
                    <li className="flex items-center gap-2">
                      🎥 Event Coverage
                    </li>
                    <li className="flex items-center gap-2">
                      🚨 Emergency Response
                    </li>
                  </ul>
                </motion.div>

                {/* States Covered */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white shadow-md rounded-xl p-6 transition-transform"
                >
                  <h3 className="text-xl font-semibold text-green-700 mb-4">
                    States We Serve
                  </h3>
                  <ul className="grid grid-cols-2 gap-y-2 text-gray-700 text-base">
                    <li>📍 Maharashtra</li>
                    <li>📍 Karnataka</li>
                    <li>📍 Tamil Nadu</li>
                    <li>📍 Uttar Pradesh</li>
                    <li>📍 Gujarat</li>
                    <li>📍 Punjab</li>
                    <li>📍 Rajasthan</li>
                    <li>📍 And More...</li>
                  </ul>
                </motion.div>
              </div>
            </section>

            {/* Enterprises vs Freelancers Section */}
            <div className="container mx-auto px-6 py-6">
              <div className="flex flex-col md:flex-row gap-6">
                {/* Enterprise Card */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                  className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeTab === "enterprises"
                      ? "border-2 border-green-500"
                      : ""
                  }`}
                  onClick={() => setActiveTab("enterprises")}
                >
                  <motion.div
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 1 }}
                    className="h-40 overflow-hidden"
                  >
                    <img
                      src="https://readdy.ai/api/search-image?query=professional%20drone%20company%20team%20with%20enterprise%20grade%20drones%2C%20business%20setting%2C%20corporate%20team%20working%20with%20advanced%20drone%20technology%2C%20clean%20modern%20office%20background%2C%20high-tech%20equipment%2C%20professional%20atmosphere&width=600&height=300&seq=2&orientation=landscape"
                      alt="Enterprise Drone Services"
                      className="w-full h-full object-cover object-top"
                    />
                  </motion.div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      For Service Providers
                    </h3>
                    <h4 className="text-base text-green-600 mb-3">
                      Monetize Your Drone Fleet
                    </h4>
                    <div className="w-12 h-1 bg-green-500 mb-4"></div>
                    <p className="text-gray-600 mb-4 text-sm">
                      Maximize Your Drone's ROI. List Your Services to India's
                      Largest Network of Clients.
                    </p>
                    <h5 className="font-semibold text-gray-800 mb-3">
                      Key Features:
                    </h5>
                    <ul className="space-y-2 text-sm">
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Fleet Monetization: Earn per-project fees for idle
                        drones.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Compliance Assurance: DGCA/Flight Permit integration.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Client Matching: AI-driven alignment with high-value
                        projects.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Payment Security: Escrow-based transactions.
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-sm">
                      Requirements: DGCA RPL/SUAS, Drone Registration (Digital
                      Sky), GSTIN.
                    </p>
                  </div>
                </motion.div>

                {/* Freelancers / Service Seekers Card */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                  className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeTab === "freelancers"
                      ? "border-2 border-green-500"
                      : ""
                  }`}
                  onClick={() => setActiveTab("freelancers")}
                >
                  <motion.div
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 1 }}
                    className="h-40 overflow-hidden"
                  >
                    <img
                      src="https://readdy.ai/api/search-image?query=freelance%20drone%20pilot%20operating%20advanced%20drone%20equipment%2C%20creative%20professional%20with%20camera%20drone%2C%20outdoor%20setting%2C%20beautiful%20landscape%2C%20action%20shot%20of%20pilot%20with%20controller%2C%20passionate%20individual%20with%20technical%20gear&width=600&height=300&seq=3&orientation=landscape"
                      alt="Freelance Drone Pilot"
                      className="w-full h-full object-cover object-top"
                    />
                  </motion.div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      For Service Seekers
                    </h3>
                    <h4 className="text-base text-green-600 mb-3">
                      Book Certified Drone Services in 2 Clicks
                    </h4>
                    <div className="w-12 h-1 bg-green-500 mb-4"></div>
                    <p className="text-gray-600 mb-4 text-sm">
                      Source Fully Compliant Drone Services with Guaranteed
                      Quality & Insurance.
                    </p>
                    <h5 className="font-semibold text-gray-800 mb-3">
                      Use Cases:
                    </h5>
                    <ul className="space-y-2 text-sm">
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Agriculture: Crop health analysis, land mapping.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Infrastructure: Bridge/pipeline inspections, solar farm
                        audits.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Government: Disaster management, surveillance.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Media: Aerial photography, live event streaming.
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-sm">
                      Process: Submit Scope → Receive Bids → Select & Deploy.{" "}
                      <br />
                      Pricing: ₹2,500 – ₹15,000/day (varies by drone). <br />
                      Insurance: Included (DGCA-compliant).
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* Compliance Section */}
            <section>
              <div className="text-center mb-6">
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="text-2xl font-bold text-gray-800"
                >
                  India-Specific Compliance
                </motion.h2>
                <div className="w-20 h-1 bg-green-500 mx-auto"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  {
                    icon: "fa-shield-alt",
                    title: "DGCA Compliance",
                    desc: "All operations adhere to Digital Sky NPNT mandates",
                  },
                  {
                    icon: "fa-user-lock",
                    title: "Verified Pilots",
                    desc: "Aadhaar-verified pilots with encrypted geofencing",
                  },
                  {
                    icon: "fa-file-contract",
                    title: "Insurance Coverage",
                    desc: "₹10L+ third-party coverage included",
                  },
                  {
                    icon: "fa-rupee-sign",
                    title: "Transparent Pricing",
                    desc: "Clear hourly/day rates with no hidden charges",
                  },
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: i * 0.2 }}
                    whileHover={{ scale: 1.05 }}
                    className="bg-white shadow-md rounded-xl p-6 text-center"
                  >
                    <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                      <i
                        className={`fas ${item.icon} text-green-600 text-xl`}
                      ></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-600 text-sm">{item.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>
          </div>
        </div>

        <div ref={formRef} className="w-full max-w-md mx-auto">
          <div className="text-center mb-10">
            <h4 className="text-3xl font-bold text-gray-800">
              Enlist your <span className="text-blue-600">DaaS Service</span>
            </h4>
            <p className="mt-2 text-gray-600">
              Please login to verify your phone number
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Number <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                maxLength="10"
                placeholder="Enter 10-digit phone number"
                onFocus={(e) => handleInputHover(e, true)}
                onBlur={(e) => handleInputHover(e, false)}
              />
            </div>

            <button
              onClick={handlePhoneSubmit}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
              className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-lg hover:shadow-md transition-all duration-300 hover:from-blue-700 hover:to-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Verify Phone Number
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Authenticated users - phone verification needed
  const shouldShowForm = phoneVerified;

  if (!shouldShowForm) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 space-y-10">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="flex flex-col items-center text-center"
            >
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
                On-Demand <span className="text-blue-600">Drone Services</span>{" "}
                Across India
              </h1>
              <p className="text-base md:text-lg text-gray-600 max-w-2xl mb-6">
                Connect with{" "}
                <span className="font-semibold">
                  DGCA-Certified Drone Pilots
                </span>
                & Fleet Operators. From agriculture to inspections and events –
                DronePlanet is your trusted Drone-as-a-Service (DaaS)
                marketplace.
              </p>

              {/* Custom Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Services Section */}
            <section>
              <div className="text-center mb-8">
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="text-2xl sm:text-3xl font-bold text-gray-800"
                >
                  Our Reach & Services
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  className="text-gray-600 mt-2 text-base md:text-lg"
                >
                  Delivering drone-powered solutions across industries and
                  geographies
                </motion.p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Services Offered */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white shadow-md rounded-xl p-6 transition-transform"
                >
                  <h3 className="text-xl font-semibold text-green-700 mb-4">
                    Services We Offer
                  </h3>
                  <ul className="space-y-2 text-gray-700 text-base">
                    <li className="flex items-center gap-2">
                      🚜 Agricultural Survey
                    </li>
                    <li className="flex items-center gap-2">
                      🏗️ Infrastructure Inspection
                    </li>
                    <li className="flex items-center gap-2">
                      🎥 Event Coverage
                    </li>
                    <li className="flex items-center gap-2">
                      🚨 Emergency Response
                    </li>
                  </ul>
                </motion.div>

                {/* States Covered */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white shadow-md rounded-xl p-6 transition-transform"
                >
                  <h3 className="text-xl font-semibold text-green-700 mb-4">
                    States We Serve
                  </h3>
                  <ul className="grid grid-cols-2 gap-y-2 text-gray-700 text-base">
                    <li>📍 Maharashtra</li>
                    <li>📍 Karnataka</li>
                    <li>📍 Tamil Nadu</li>
                    <li>📍 Uttar Pradesh</li>
                    <li>📍 Gujarat</li>
                    <li>📍 Punjab</li>
                    <li>📍 Rajasthan</li>
                    <li>📍 And More...</li>
                  </ul>
                </motion.div>
              </div>
            </section>

            {/* Enterprises vs Freelancers Section */}
            <div className="container mx-auto px-6 py-6">
              <div className="flex flex-col md:flex-row gap-6">
                {/* Enterprise Card */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                  className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeTab === "enterprises"
                      ? "border-2 border-green-500"
                      : ""
                  }`}
                  onClick={() => setActiveTab("enterprises")}
                >
                  <motion.div
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 1 }}
                    className="h-40 overflow-hidden"
                  >
                    <img
                      src="https://readdy.ai/api/search-image?query=professional%20drone%20company%20team%20with%20enterprise%20grade%20drones%2C%20business%20setting%2C%20corporate%20team%20working%20with%20advanced%20drone%20technology%2C%20clean%20modern%20office%20background%2C%20high-tech%20equipment%2C%20professional%20atmosphere&width=600&height=300&seq=2&orientation=landscape"
                      alt="Enterprise Drone Services"
                      className="w-full h-full object-cover object-top"
                    />
                  </motion.div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      For Service Providers
                    </h3>
                    <h4 className="text-base text-green-600 mb-3">
                      Monetize Your Drone Fleet
                    </h4>
                    <div className="w-12 h-1 bg-green-500 mb-4"></div>
                    <p className="text-gray-600 mb-4 text-sm">
                      Maximize Your Drone's ROI. List Your Services to India's
                      Largest Network of Clients.
                    </p>
                    <h5 className="font-semibold text-gray-800 mb-3">
                      Key Features:
                    </h5>
                    <ul className="space-y-2 text-sm">
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Fleet Monetization: Earn per-project fees for idle
                        drones.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Compliance Assurance: DGCA/Flight Permit integration.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Client Matching: AI-driven alignment with high-value
                        projects.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Payment Security: Escrow-based transactions.
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-sm">
                      Requirements: DGCA RPL/SUAS, Drone Registration (Digital
                      Sky), GSTIN.
                    </p>
                  </div>
                </motion.div>

                {/* Freelancers / Service Seekers Card */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                  className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeTab === "freelancers"
                      ? "border-2 border-green-500"
                      : ""
                  }`}
                  onClick={() => setActiveTab("freelancers")}
                >
                  <motion.div
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 1 }}
                    className="h-40 overflow-hidden"
                  >
                    <img
                      src="https://readdy.ai/api/search-image?query=freelance%20drone%20pilot%20operating%20advanced%20drone%20equipment%2C%20creative%20professional%20with%20camera%20drone%2C%20outdoor%20setting%2C%20beautiful%20landscape%2C%20action%20shot%20of%20pilot%20with%20controller%2C%20passionate%20individual%20with%20technical%20gear&width=600&height=300&seq=3&orientation=landscape"
                      alt="Freelance Drone Pilot"
                      className="w-full h-full object-cover object-top"
                    />
                  </motion.div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      For Service Seekers
                    </h3>
                    <h4 className="text-base text-green-600 mb-3">
                      Book Certified Drone Services in 2 Clicks
                    </h4>
                    <div className="w-12 h-1 bg-green-500 mb-4"></div>
                    <p className="text-gray-600 mb-4 text-sm">
                      Source Fully Compliant Drone Services with Guaranteed
                      Quality & Insurance.
                    </p>
                    <h5 className="font-semibold text-gray-800 mb-3">
                      Use Cases:
                    </h5>
                    <ul className="space-y-2 text-sm">
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Agriculture: Crop health analysis, land mapping.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Infrastructure: Bridge/pipeline inspections, solar farm
                        audits.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Government: Disaster management, surveillance.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Media: Aerial photography, live event streaming.
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-sm">
                      Process: Submit Scope → Receive Bids → Select & Deploy.{" "}
                      <br />
                      Pricing: ₹2,500 – ₹15,000/day (varies by drone). <br />
                      Insurance: Included (DGCA-compliant).
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* Compliance Section */}
            <section>
              <div className="text-center mb-6">
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="text-2xl font-bold text-gray-800"
                >
                  India-Specific Compliance
                </motion.h2>
                <div className="w-20 h-1 bg-green-500 mx-auto"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  {
                    icon: "fa-shield-alt",
                    title: "DGCA Compliance",
                    desc: "All operations adhere to Digital Sky NPNT mandates",
                  },
                  {
                    icon: "fa-user-lock",
                    title: "Verified Pilots",
                    desc: "Aadhaar-verified pilots with encrypted geofencing",
                  },
                  {
                    icon: "fa-file-contract",
                    title: "Insurance Coverage",
                    desc: "₹10L+ third-party coverage included",
                  },
                  {
                    icon: "fa-rupee-sign",
                    title: "Transparent Pricing",
                    desc: "Clear hourly/day rates with no hidden charges",
                  },
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: i * 0.2 }}
                    whileHover={{ scale: 1.05 }}
                    className="bg-white shadow-md rounded-xl p-6 text-center"
                  >
                    <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                      <i
                        className={`fas ${item.icon} text-green-600 text-xl`}
                      ></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-600 text-sm">{item.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>
          </div>
        </div>

        <div
          ref={formRef}
          className="min-h-screen flex items-center justify-center px-4"
        >
          <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden">
            {/* Header */}
            <div className="bg-blue-600 px-6 py-8 text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 bg-white rounded-full mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Register Your DaaS Service
              </h1>
              <p className="text-blue-100">
                Complete your registration in just 2 simple steps
              </p>
            </div>

            {/* Stepper */}
            <div className="flex justify-center px-8 pt-6">
              <div className="w-full max-w-md">
                <div className="flex items-center">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">
                      1
                    </div>
                    <div className="text-sm font-medium text-blue-600 mt-1">
                      Phone Verification
                    </div>
                  </div>
                  <div className="flex-1 h-1 bg-gray-200 mx-2"></div>
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center font-bold">
                      2
                    </div>
                    <div className="text-sm font-medium text-gray-500 mt-1">
                      Service Details
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Phone input section */}
            <div className="px-6 py-8 sm:px-10 relative">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-gray-800">
                  Verify Your Phone Number
                </h2>
                <p className="text-gray-600 mt-2">
                  We'll send a 4-digit verification code
                </p>
              </div>

              <div className="max-w-md mx-auto space-y-6">
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span className="text-gray-500 sm:text-sm">+91</span>
                    </div>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={phoneNumber}
                      onChange={(e) =>
                        setPhoneNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10),
                        )
                      }
                      maxLength="10"
                      className="block w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                      placeholder=""
                      inputMode="numeric"
                      onFocus={(e) => handleInputHover(e, true)}
                      onBlur={(e) => handleInputHover(e, false)}
                    />
                  </div>
                </div>

                <div className="pt-2">
                  <button
                    onClick={handlePhoneSubmit}
                    disabled={loading || phoneNumber.length !== 10}
                    className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                      loading || phoneNumber.length !== 10
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    {loading ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Sending OTP...
                      </>
                    ) : (
                      "Send Verification Code"
                    )}
                  </button>
                </div>
              </div>

              {/* OTP Popup Overlay (slightly upper inside card) */}
              {showModal && (
                <div className="absolute inset-0 flex items-start justify-center bg-black/30 backdrop-blur-sm">
                  <div className="-mt-32 bg-white rounded-xl shadow-xl w-full max-w-sm p-6 relative">
                    <OtpVerify
                      verifyOtp={verifyOtp}
                      resendOtp={resendOtp}
                      onClose={onCloseModal}
                      phoneNumber={phoneNumber}
                      loading={otpLoading}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Full form for verified users
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 space-y-10">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="flex flex-col items-center text-center"
            >
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
                On-Demand <span className="text-blue-600">Drone Services</span>{" "}
                Across India
              </h1>
              <p className="text-base md:text-lg text-gray-600 max-w-2xl">
                Connect with{" "}
                <span className="font-semibold">
                  DGCA-Certified Drone Pilots
                </span>
                & Fleet Operators. From agriculture to inspections and events –
                DronePlanet is your trusted Drone-as-a-Service (DaaS)
                marketplace.
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Services Section */}
            <section>
              <div className="text-center mb-8">
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="text-2xl sm:text-3xl font-bold text-gray-800"
                >
                  Our Reach & Services
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  className="text-gray-600 mt-2 text-base md:text-lg"
                >
                  Delivering drone-powered solutions across industries and
                  geographies
                </motion.p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Services Offered */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white shadow-md rounded-xl p-6 transition-transform"
                >
                  <h3 className="text-xl font-semibold text-green-700 mb-4">
                    Services We Offer
                  </h3>
                  <ul className="space-y-2 text-gray-700 text-base">
                    <li className="flex items-center gap-2">
                      🚜 Agricultural Survey
                    </li>
                    <li className="flex items-center gap-2">
                      🏗️ Infrastructure Inspection
                    </li>
                    <li className="flex items-center gap-2">
                      🎥 Event Coverage
                    </li>
                    <li className="flex items-center gap-2">
                      🚨 Emergency Response
                    </li>
                  </ul>
                </motion.div>

                {/* States Covered */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white shadow-md rounded-xl p-6 transition-transform"
                >
                  <h3 className="text-xl font-semibold text-green-700 mb-4">
                    States We Serve
                  </h3>
                  <ul className="grid grid-cols-2 gap-y-2 text-gray-700 text-base">
                    <li>📍 Maharashtra</li>
                    <li>📍 Karnataka</li>
                    <li>📍 Tamil Nadu</li>
                    <li>📍 Uttar Pradesh</li>
                    <li>📍 Gujarat</li>
                    <li>📍 Punjab</li>
                    <li>📍 Rajasthan</li>
                    <li>📍 And More...</li>
                  </ul>
                </motion.div>
              </div>
            </section>

            {/* Enterprises vs Freelancers Section */}
            <div className="container mx-auto px-6 py-6">
              <div className="flex flex-col md:flex-row gap-6">
                {/* Enterprise Card */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                  className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeTab === "enterprises"
                      ? "border-2 border-green-500"
                      : ""
                  }`}
                  onClick={() => setActiveTab("enterprises")}
                >
                  <motion.div
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 1 }}
                    className="h-40 overflow-hidden"
                  >
                    <img
                      src="https://readdy.ai/api/search-image?query=professional%20drone%20company%20team%20with%20enterprise%20grade%20drones%2C%20business%20setting%2C%20corporate%20team%20working%20with%20advanced%20drone%20technology%2C%20clean%20modern%20office%20background%2C%20high-tech%20equipment%2C%20professional%20atmosphere&width=600&height=300&seq=2&orientation=landscape"
                      alt="Enterprise Drone Services"
                      className="w-full h-full object-cover object-top"
                    />
                  </motion.div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      For Service Providers
                    </h3>
                    <h4 className="text-base text-green-600 mb-3">
                      Monetize Your Drone Fleet
                    </h4>
                    <div className="w-12 h-1 bg-green-500 mb-4"></div>
                    <p className="text-gray-600 mb-4 text-sm">
                      Maximize Your Drone's ROI. List Your Services to India's
                      Largest Network of Clients.
                    </p>
                    <h5 className="font-semibold text-gray-800 mb-3">
                      Key Features:
                    </h5>
                    <ul className="space-y-2 text-sm">
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Fleet Monetization: Earn per-project fees for idle
                        drones.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Compliance Assurance: DGCA/Flight Permit integration.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Client Matching: AI-driven alignment with high-value
                        projects.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Payment Security: Escrow-based transactions.
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-sm">
                      Requirements: DGCA RPL/SUAS, Drone Registration (Digital
                      Sky), GSTIN.
                    </p>
                  </div>
                </motion.div>

                {/* Freelancers / Service Seekers Card */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                  className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeTab === "freelancers"
                      ? "border-2 border-green-500"
                      : ""
                  }`}
                  onClick={() => setActiveTab("freelancers")}
                >
                  <motion.div
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 1 }}
                    className="h-40 overflow-hidden"
                  >
                    <img
                      src="https://readdy.ai/api/search-image?query=freelance%20drone%20pilot%20operating%20advanced%20drone%20equipment%2C%20creative%20professional%20with%20camera%20drone%2C%20outdoor%20setting%2C%20beautiful%20landscape%2C%20action%20shot%20of%20pilot%20with%20controller%2C%20passionate%20individual%20with%20technical%20gear&width=600&height=300&seq=3&orientation=landscape"
                      alt="Freelance Drone Pilot"
                      className="w-full h-full object-cover object-top"
                    />
                  </motion.div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      For Service Seekers
                    </h3>
                    <h4 className="text-base text-green-600 mb-3">
                      Book Certified Drone Services in 2 Clicks
                    </h4>
                    <div className="w-12 h-1 bg-green-500 mb-4"></div>
                    <p className="text-gray-600 mb-4 text-sm">
                      Source Fully Compliant Drone Services with Guaranteed
                      Quality & Insurance.
                    </p>
                    <h5 className="font-semibold text-gray-800 mb-3">
                      Use Cases:
                    </h5>
                    <ul className="space-y-2 text-sm">
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Agriculture: Crop health analysis, land mapping.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Infrastructure: Bridge/pipeline inspections, solar farm
                        audits.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Government: Disaster management, surveillance.
                      </li>
                      <li className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2"></i>{" "}
                        Media: Aerial photography, live event streaming.
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-sm">
                      Process: Submit Scope → Receive Bids → Select & Deploy.{" "}
                      <br />
                      Pricing: ₹2,500 – ₹15,000/day (varies by drone). <br />
                      Insurance: Included (DGCA-compliant).
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* Compliance Section */}
            <section>
              <div className="text-center mb-6">
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="text-2xl font-bold text-gray-800"
                >
                  India-Specific Compliance
                </motion.h2>
                <div className="w-20 h-1 bg-green-500 mx-auto"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  {
                    icon: "fa-shield-alt",
                    title: "DGCA Compliance",
                    desc: "All operations adhere to Digital Sky NPNT mandates",
                  },
                  {
                    icon: "fa-user-lock",
                    title: "Verified Pilots",
                    desc: "Aadhaar-verified pilots with encrypted geofencing",
                  },
                  {
                    icon: "fa-file-contract",
                    title: "Insurance Coverage",
                    desc: "₹10L+ third-party coverage included",
                  },
                  {
                    icon: "fa-rupee-sign",
                    title: "Transparent Pricing",
                    desc: "Clear hourly/day rates with no hidden charges",
                  },
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: i * 0.2 }}
                    whileHover={{ scale: 1.05 }}
                    className="bg-white shadow-md rounded-xl p-6 text-center"
                  >
                    <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                      <i
                        className={`fas ${item.icon} text-green-600 text-xl`}
                      ></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-600 text-sm">{item.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>
          </div>
        </div>

        <div ref={formRef} className="text-center mb-10">
          <h1 className="text-2xl font-bold text-gray-800 mb-3">
            Register Your <span className="text-blue-600">DaaS Service</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join our network of certified drone service providers and offer your
            expertise to clients worldwide.
          </p>
        </div>

        <div
          ref={formRef}
          className="bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          {/* Progress Bar */}
          <div className="bg-gray-100 px-6 py-4">
            <div className="flex items-center">
              <div className="flex-1">
                <div className="text-sm font-medium text-gray-700">
                  Registration Progress
                </div>
                <div className="mt-1 flex items-center">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all duration-500"
                      style={{ width: "50%" }}
                    ></div>
                  </div>
                  <span className="ml-4 text-xs font-medium text-gray-600">
                    50%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8">
            {/* User Type Selection */}
            <div className="md:col-span-2 mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </span>
                Account Type
              </h2>
              <div className="flex flex-col sm:flex-row sm:justify-center sm:gap-24 gap-4 mt-4">
                <div className="flex items-center form-field">
                  <input
                    className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    type="radio"
                    name="userType"
                    id="individual"
                    value="individual"
                    checked={formData.userType === "individual"}
                    onChange={handleChange}
                    required
                  />
                  <label
                    htmlFor="individual"
                    className="ml-2 block text-gray-700 font-medium"
                  >
                    Individual/Freelancer
                  </label>
                </div>
                <div className="flex items-center form-field">
                  <input
                    className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    type="radio"
                    name="userType"
                    id="company"
                    value="company"
                    checked={formData.userType === "company"}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="company"
                    className="ml-2 block text-gray-700 font-medium"
                  >
                    Company as a co-partner
                  </label>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Contact Information Section */}
              <div className="md:col-span-2">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </span>
                  Contact Information
                </h2>
              </div>

              {/* Name */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="name"
                >
                  <PersonOutlineIcon className="h-4 w-4 text-gray-500 mr-1" />
                  Your Name <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Enter full name"
                  required
                />
              </div>

              {/* Email */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="email"
                >
                  <EmailOutlinedIcon className="h-4 w-4 text-gray-500 mr-1" />
                  Email <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="company@example.com"
                  required
                />
              </div>

              {/* Location */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="location"
                >
                  <LocationOnOutlinedIcon className="h-4 w-4 text-gray-500 mr-1" />
                  Location <span className="text-red-500 ml-1">*</span>
                </label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_KEY}
                  onPlaceSelected={handlePlaceSelected}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  options={{
                    types: ["(cities)"],
                    componentRestrictions: { country: "in" },
                  }}
                  placeholder="Enter your city"
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                />
              </div>

              {/* Address */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="address"
                >
                  <HomeOutlinedIcon className="h-4 w-4 text-gray-500 mr-1" />
                  Address <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Enter your complete address"
                  required
                />
              </div>

              {/* Company Fields (conditionally rendered) */}
              {formData.userType === "company" && (
                <>
                  <div className="md:col-span-2">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                      <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                        <svg
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                          />
                        </svg>
                      </span>
                      Company Information
                    </h2>
                  </div>

                  <div className="form-field">
                    <label
                      className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                      htmlFor="companyName"
                    >
                      <BusinessIcon
                        fontSize="small"
                        className="text-gray-500 mr-1"
                      />
                      Company Name <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      onFocus={(e) => handleInputHover(e, true)}
                      onBlur={(e) => handleInputHover(e, false)}
                      placeholder="Your company name"
                      required
                    />
                  </div>

                  <div className="form-field">
                    <label
                      className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                      htmlFor="companyAddress"
                    >
                      <LocationOnIcon
                        fontSize="small"
                        className="text-gray-500 mr-1"
                      />
                      Company Address{" "}
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      type="text"
                      name="companyAddress"
                      value={formData.companyAddress}
                      onChange={handleChange}
                      onFocus={(e) => handleInputHover(e, true)}
                      onBlur={(e) => handleInputHover(e, false)}
                      placeholder="Company complete address"
                      required
                    />
                  </div>
                </>
              )}

              {/* Security Section */}
              <div className="md:col-span-2 mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </span>
                  Account Security
                </h2>
              </div>

              {/* Password */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="password"
                >
                  <LockIcon fontSize="small" className="text-gray-500 mr-1" />
                  Password <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    className={`w-full px-4 py-3 rounded-lg border ${
                      passwordValidation.isValid
                        ? "border-green-500"
                        : "border-red-500"
                    } focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10`}
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                    placeholder="Create a strong password"
                    required
                  />
                  {passwordValidation.isValid ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CheckCircleIcon
                        className="text-green-500"
                        fontSize="small"
                      />
                    </div>
                  ) : (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CancelIcon className="text-red-500" fontSize="small" />
                    </div>
                  )}
                </div>
                {!passwordValidation.isValid && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <ErrorOutlineIcon fontSize="small" className="mr-1" />
                    Password must be at least 6 characters long
                  </p>
                )}
              </div>

              {/* Confirm Password */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="confirmPassword"
                >
                  <LockIcon fontSize="small" className="text-gray-500 mr-1" />
                  Confirm Password <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    className={`w-full px-4 py-3 rounded-lg border ${
                      passwordValidation.match === true
                        ? "border-green-500"
                        : passwordValidation.match === false
                          ? "border-red-500"
                          : "border-gray-300"
                    } focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10`}
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                    placeholder="Confirm your password"
                    required
                  />
                  {passwordValidation.match === true ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CheckCircleIcon
                        className="text-green-500"
                        fontSize="small"
                      />
                    </div>
                  ) : passwordValidation.match === false ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <CancelIcon className="text-red-500" fontSize="small" />
                    </div>
                  ) : null}
                </div>
                {passwordValidation.match === false && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <ErrorOutlineIcon fontSize="small" className="mr-1" />
                    Passwords do not match
                  </p>
                )}
                {passwordValidation.match === true && (
                  <p className="mt-2 text-sm text-green-600 flex items-center">
                    <CheckCircleIcon fontSize="small" className="mr-1" />
                    Passwords match
                  </p>
                )}
              </div>
            </div>

            {/* Terms and Conditions */}
            <div className="flex items-start mt-8 form-field p-4 bg-blue-50 rounded-lg">
              <div className="flex items-center h-5">
                <input
                  type="checkbox"
                  id="subsidyAcknowledgement"
                  name="subsidyAcknowledgement"
                  checked={checkboxState.subsidyAcknowledgement}
                  onChange={handleCheckboxChange}
                  className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
              </div>
              <div className="ml-3 text-sm">
                <label
                  htmlFor="subsidyAcknowledgement"
                  className="font-medium text-gray-700"
                >
                  I Accept The{" "}
                  <Link
                    to="/terms-and-conditions"
                    className="text-blue-600 hover:text-blue-500 underline font-semibold"
                  >
                    Terms and Conditions
                  </Link>{" "}
                  and acknowledge that I have read the{" "}
                  <Link
                    to="/privacy-policy"
                    className="text-blue-600 hover:text-blue-500 underline font-semibold"
                  >
                    Privacy Policy
                  </Link>
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <button
              onClick={submitHandle}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
              className="w-full mt-6 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-md hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 flex justify-center items-center gap-2"
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" />
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <span>Validate and Proceed to Next</span>
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Institute Form Component

const InstituteForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const userId = Cookies.get("userId");
  const formRef = useRef(null);
  const successRef = useRef(null);

  // Verification states
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCheckingVerification, setIsCheckingVerification] = useState(true);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [checkingRegistration, setCheckingRegistration] = useState(true);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [billingCycle, setBillingCycle] = useState("annually");

  const pricing = {
    pro: billingCycle === "annually" ? 699 : 999,
    premium: billingCycle === "annually" ? 2099 : 2999,
    enterprise: billingCycle === "annually" ? 2799 : 3999,
  };

  const plans = [
    {
      title: "Pro",
      price: pricing.pro,
      features: [
        "100 leads /month",
        "20-30 Students",
        "Access to community support",
        "Basic profile listing",
        "Email insights & analytics",
        "Support response within 48 hours",
      ],
    },
    {
      title: "Premium",
      price: pricing.premium,
      popular: true,
      features: [
        "200 leads /month",
        "30-40 Students",
        "Priority email & call support",
        "Premium placement in listings",
        "Detailed performance analytics",
        "Lead scoring & filters",
        "Support response within 12 hours",
      ],
    },
    {
      title: "Enterprise",
      price: pricing.enterprise,
      features: [
        "350 leads /month",
        "40-50 Students",
        "Dedicated account manager",
        "Custom integrations",
        "Advanced analytics dashboard",
        "Full profile customization",
        "Support response within 4 hours",
      ],
    },
  ];
  // Form data state
  const [formData, setFormData] = useState({
    name: "",
    instituteName: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    location: [],
  });

  // Password validation state
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: false,
    match: null,
  });

  // File states
  const [instituteImage, setInstituteImage] = useState(null);
  const [imageSizeValid, setImageSizeValid] = useState(null);

  // Checkboxes
  const [checkboxState, setCheckboxState] = useState({
    subsidyAcknowledgement: false,
  });

  // Animation effects
  useEffect(() => {
    if (alreadyRegistered && successRef.current) {
      // Animate success message
      gsap.fromTo(
        successRef.current,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, ease: "elastic.out(1, 0.5)" },
      );

      // Animate checkmark
      gsap.fromTo(
        ".success-checkmark",
        { scale: 0, rotation: -180 },
        {
          scale: 1,
          rotation: 0,
          duration: 0.8,
          ease: "back.out(1.7)",
          delay: 0.3,
        },
      );
    }
  }, [alreadyRegistered]);

  useEffect(() => {
    if (formRef.current) {
      // Animate form elements sequentially
      gsap.fromTo(
        ".form-field",
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: "power2.out",
          delay: 0.3,
        },
      );
    }
  }, [phoneVerified, formRef]);

  // Check authentication and verification status on mount
  useEffect(() => {
    if (!token) {
      setIsCheckingVerification(false);
    } else {
      checkPhoneVerification();
    }
  }, [token, dispatch]);

  // Check registration status
  useEffect(() => {
    const checkRegistrationStatus = async () => {
      if (userId) {
        try {
          const response = await axios.get(
            process.env.REACT_APP_API_URL +
              `/checkInstituteRegistration/${userId}`,
          );
          console.log("Registration check response:", response.data);

          if (
            response.data.registered === true ||
            response.data.message === "Institute found"
          ) {
            setAlreadyRegistered(true);
          }
        } catch (error) {
          console.error("Error checking registration status:", error);
        } finally {
          setCheckingRegistration(false);
        }
      } else {
        setCheckingRegistration(false);
      }
    };

    checkRegistrationStatus();
  }, [userId]);

  // Check phone verification status
  const checkPhoneVerification = async () => {
    try {
      setIsCheckingVerification(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `/getInterstedData/${userId}`,
      );
      console.log("Verification check response:", response.data);

      if (response.data.data) {
        setPhoneNumber(response.data.data.phoneNumber);

        if (response.data.data.verified) {
          setPhoneVerified(true);
          setFormData((prev) => ({
            ...prev,
            phoneNumber: response.data.data.phoneNumber,
            name: response.data.data.name || "",
            email: response.data.data.email || "",
            instituteName: response.data.data.instituteName || "",
            address: response.data.data.address || "",
            password: "",
            confirmPassword: "",
          }));
        } else {
          setPhoneVerified(true);
        }
      }
    } catch (error) {
      console.error("Error checking phone verification:", error);
    } finally {
      setIsCheckingVerification(false);
    }
  };

  // Handle input hover effects
  const handleInputHover = (e, isHover) => {
    gsap.to(e.target, {
      y: isHover ? -2 : 0,
      boxShadow: isHover ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
      duration: 0.3,
      ease: "power1.out",
    });
  };

  // Handle button hover effects
  const handleButtonHover = (e, isHover) => {
    gsap.to(e.target, {
      scale: isHover ? 1.02 : 1,
      boxShadow: isHover ? "0 5px 15px rgba(59, 130, 246, 0.4)" : "none",
      duration: 0.3,
    });
  };

  // Handle phone number submission
  const handlePhoneSubmit = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    if (!phoneNumber || phoneNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    setLoading(true);
    try {
      await axios.post(process.env.REACT_APP_API_URL + "/savePhone", {
        phoneNumber,
        type: "institute",
        userId,
      });

      setOtpLoading(true);
      const otpResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          phoneNumber,
          userId,
        },
      );

      if (otpResponse.data.status === "success") {
        toast.success(otpResponse.data.message || "OTP sent successfully");
        setShowModal(true);
      } else {
        toast.error(otpResponse.data.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to initiate verification",
      );
      console.error(error);
    } finally {
      setLoading(false);
      setOtpLoading(false);
    }
  };

  // Verify OTP
  const verifyOtp = async (otp) => {
    try {
      setOtpLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verifyOtp`,
        {
          phoneNumber,
          otp,
          userId,
        },
      );

      if (response.data.status === "success") {
        toast.success(
          response.data.message || "Phone number verified successfully",
        );
        setPhoneVerified(true);
        setFormData((prev) => ({ ...prev, phoneNumber }));
        setShowModal(false);

        // Store the active tab before reloading
        const activeTab =
          localStorage.getItem("activeRegistrationTab") || "institute";
        localStorage.setItem("activeRegistrationTab", activeTab);

        setTimeout(() => {
          window.location.reload();
        }, 1000);

        return true;
      } else {
        toast.error(response.data.message || "Invalid OTP");
        return false;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
      console.error(error);
      return false;
    } finally {
      setOtpLoading(false);
    }
  };

  // Resend OTP
  const resendOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/resendOtp`,
        {
          phoneNumber,
          userId,
        },
      );

      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP resent successfully");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
      console.error(error);
    } finally {
      setOtpLoading(false);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber" && !/^\d{0,10}$/.test(value)) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "password") {
      setPasswordValidation((prev) => ({
        ...prev,
        isValid: value.length >= 6,
      }));
    }

    if (name === "confirmPassword") {
      setPasswordValidation((prev) => ({
        ...prev,
        match: value === formData.password ? true : value ? false : null,
      }));
    }
  };

  // Handle image changes
  const handleImageChange = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setInstituteImage(imageFile);
      const isUnder1MB = imageFile.size <= 1024 * 1024;
      setImageSizeValid(isUnder1MB);
    } else {
      setInstituteImage(null);
      setImageSizeValid(null);
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxState({
      ...checkboxState,
      [name]: checked,
    });
  };

  // Handle form submission
  const submitHandle = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    // Create submission data
    const submissionData = {
      ...formData,
      phoneNumber: phoneNumber || formData.phoneNumber,
      userId,
    };

    // Validate required fields
    const requiredFields = [
      "name",
      "instituteName",
      "phoneNumber",
      "email",
      "password",
      "address",
    ];

    const missingFields = requiredFields.filter(
      (field) => !submissionData[field],
    );

    if (missingFields.length > 0) {
      toast.error(`Missing required fields: ${missingFields.join(", ")}`);
      return;
    }

    if (!passwordValidation.isValid) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    if (passwordValidation.match === false) {
      toast.error("Passwords don't match");
      return;
    }

    if (!checkboxState.subsidyAcknowledgement) {
      toast.error("Please accept the terms and conditions");
      return;
    }

    if (!instituteImage) {
      toast.error("Please upload institute image");
      return;
    }

    if (imageSizeValid === false) {
      toast.error("Image size must be under 1MB");
      return;
    }

    try {
      setLoading(true);

      const formDataToSend = new FormData();
      formDataToSend.append("name", submissionData.name);
      formDataToSend.append("instituteName", submissionData.instituteName);
      formDataToSend.append("email", submissionData.email);
      formDataToSend.append("phoneNumber", submissionData.phoneNumber);
      formDataToSend.append("password", submissionData.password);
      formDataToSend.append("address", submissionData.address);
      formDataToSend.append("location", submissionData.location.join(","));
      formDataToSend.append("userId", userId);

      if (instituteImage) {
        formDataToSend.append("image", instituteImage);
      }

      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/addInstitute",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.status === "success") {
        toast.success(
          response.data.message || "Institute registration successful!",
        );
        setAlreadyRegistered(true);
        if (response.data.status === "success") {
          window.location.reload();
        }
      } else {
        toast.error(response.data.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(
        error.response?.data?.message ||
          "Institute registration failed. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle location selection
  const handlePlaceSelected = (place) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      address: place.formatted_address,
      location: [place.geometry.location.lat(), place.geometry.location.lng()],
    }));
  };

  // Close modal
  const onCloseModal = () => {
    setShowModal(false);
  };

  // Loading state
  if (isCheckingVerification) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (alreadyRegistered) {
    return (
      <div
        id="success-message"
        ref={successRef}
        className="flex justify-center items-center min-h-screen py-8 px-4"
        style={{ paddingTop: "700px" }}
      >
        <div className="flex justify-center items-center min-h-[60vh] bg-gradient-to-br from-green-50 to-white px-4">
          <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl max-w-md w-full text-center">
            <div className="flex justify-center mb-4">
              <div className="success-checkmark bg-green-100 p-4 rounded-full shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 text-green-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              Institute Registration Successful!
            </h2>
            <p className="text-base text-gray-600 mb-1">
              Your institute has been registered successfully.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Thank you for joining{" "}
              <span className="font-medium text-green-600">Drone Planet</span>.
            </p>
            <div className="flex justify-center gap-4">
              <Link
                to="/"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition transform hover:scale-105"
              >
                Go to Home
              </Link>
              <a
                href="mailto:support@droneplanet.in"
                className="px-4 py-2 text-sm border border-blue-600 text-blue-600 rounded hover:bg-blue-50 transition"
              >
                Support
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Unauthenticated users
  if (!token) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 space-y-12">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="flex flex-col items-center text-center space-y-4"
            >
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                Empower Your <span className="text-blue-600">RPTO Growth</span>{" "}
                with Consistent, High-Quality Student Leads
              </h1>
              <p className="text-lg text-gray-600 max-w-2xl">
                Tap into a nationwide pipeline for reliable, pre-qualified leads
                every month. Claim your first{" "}
                <span className="font-semibold text-blue-700">
                  5 leads free!
                </span>
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Why Choose Us */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                Why Choose Our Subscription?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    icon: "🎯",
                    title: "Market Expertise & Precision",
                    desc: "We connect you with pre-qualified drone students using advanced targeting algorithms.",
                  },
                  {
                    icon: "📈",
                    title: "Predictable, Scalable Growth",
                    desc: "Stay consistent with monthly leads and scale confidently with demand.",
                  },
                  {
                    icon: "✅",
                    title: "Quality Assurance",
                    desc: "Every lead is verified for genuine interest and basic qualifications.",
                  },
                ].map((c, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -6, scale: 1.02 }}
                    transition={{ type: "spring", stiffness: 200 }}
                    className="bg-white p-6 rounded-2xl shadow-lg text-center"
                  >
                    <div className="w-12 h-12 flex items-center justify-center bg-blue-100 text-blue-600 rounded-xl text-2xl mx-auto mb-3">
                      {c.icon}
                    </div>
                    <h3 className="text-lg font-semibold text-gray-800">
                      {c.title}
                    </h3>
                    <p className="text-gray-600 mt-2 text-sm">{c.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* How It Works */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                How It Works
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    step: "1",
                    title: "Define Your Target Profile",
                    desc: "We align demographics, region, certification type & budget range.",
                  },
                  {
                    step: "2",
                    title: "Receive & Review Leads",
                    desc: "Get leads in your dashboard — act within 48 hours.",
                  },
                  {
                    step: "3",
                    title: "Engage & Convert",
                    desc: "Use proven scripts and templates to boost conversions by 30%.",
                  },
                ].map((s, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.15 }}
                    className="bg-white p-6 rounded-2xl shadow-md text-center relative"
                  >
                    <span
                      className="absolute -top-6 left-1/2 transform -translate-x-1/2 
                 w-14 h-14 flex items-center justify-center 
                 bg-blue-600 text-white rounded-full 
                 font-bold text-xl shadow-lg"
                    >
                      {s.step}
                    </span>

                    <h3 className="text-md font-semibold text-gray-900 mt-5">
                      {s.title}
                    </h3>
                    <p className="text-gray-600 mt-1 text-sm">{s.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Pricing */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                Select Your Package
              </h2>

              {/* Billing Toggle */}
              <div className="flex justify-center mb-6">
                <div className="flex space-x-2 bg-gray-100 p-1 rounded-full">
                  {["monthly", "annually"].map((cycle) => (
                    <button
                      key={cycle}
                      onClick={() => setBillingCycle(cycle)}
                      className={`px-3 py-1 text-sm font-medium rounded-full transition ${
                        billingCycle === cycle
                          ? "bg-blue-600 text-white"
                          : "text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      {cycle === "annually" ? "Annually (30% OFF)" : "Monthly"}
                    </button>
                  ))}
                </div>
              </div>

              {/* Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {plans.map((plan, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -6, scale: 1.02 }}
                    className={`bg-white rounded-xl shadow-lg overflow-hidden relative p-5 transition flex flex-col h-full ${
                      plan.popular ? "ring-2 ring-blue-600" : ""
                    }`}
                  >
                    {/* Top content */}
                    <div className="flex-grow">
                      <h3 className="text-lg font-bold">{plan.title}</h3>
                      <p className="text-2xl font-extrabold mt-1">
                        ₹{plan.price}
                        <span className="text-gray-500 text-xs">/month</span>
                      </p>
                      <ul className="mt-4 space-y-2 text-sm text-gray-600">
                        {plan.features.map((f, idx) => (
                          <li key={idx}>✅ {f}</li>
                        ))}
                      </ul>
                    </div>

                    {/* Button fixed at bottom */}
                    <div className="mt-4">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-medium transition text-sm"
                      >
                        Subscribe
                      </motion.button>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Custom Contact */}
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                className="mt-8 text-center"
              >
                <h3 className="text-lg font-semibold text-blue-700">
                  Need something custom?
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Let’s talk about a tailored solution for your organization.
                </p>
                <a
                  href="https://wa.me/919773571992"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-5 rounded-full font-medium transition text-sm"
                >
                  Contact Sales
                </a>
              </motion.div>
            </section>
          </div>
        </div>
        <div ref={formRef} className="w-full max-w-md mx-auto">
          <div className="text-center mb-10">
            <h4 className="text-3xl font-bold text-gray-800">
              Register Your <span className="text-blue-600">Institute</span>
            </h4>
            <p className="mt-2 text-gray-600">
              Please login to verify your phone number
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Number <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                maxLength="10"
                placeholder="Enter 10-digit phone number"
                onFocus={(e) => handleInputHover(e, true)}
                onBlur={(e) => handleInputHover(e, false)}
              />
            </div>

            <button
              onClick={handlePhoneSubmit}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
              className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-lg hover:shadow-md transition-all duration-300 hover:from-blue-700 hover:to-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Verify Phone Number
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Authenticated users - phone verification needed
  const shouldShowForm = phoneVerified;

  if (!shouldShowForm) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2 sm:px-4 md:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 space-y-12">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="flex flex-col items-center text-center space-y-4"
            >
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                Empower Your <span className="text-blue-600">RPTO Growth</span>{" "}
                with Consistent, High-Quality Student Leads
              </h1>
              <p className="text-lg text-gray-600 max-w-2xl">
                Tap into a nationwide pipeline for reliable, pre-qualified leads
                every month. Claim your first{" "}
                <span className="font-semibold text-blue-700">
                  5 leads free!
                </span>
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                style={{
                  padding: "12px 32px",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #2563eb, #4f46e5)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
              >
                Get Started
              </motion.button>
            </motion.section>

            {/* Why Choose Us */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                Why Choose Our Subscription?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    icon: "🎯",
                    title: "Market Expertise & Precision",
                    desc: "We connect you with pre-qualified drone students using advanced targeting algorithms.",
                  },
                  {
                    icon: "📈",
                    title: "Predictable, Scalable Growth",
                    desc: "Stay consistent with monthly leads and scale confidently with demand.",
                  },
                  {
                    icon: "✅",
                    title: "Quality Assurance",
                    desc: "Every lead is verified for genuine interest and basic qualifications.",
                  },
                ].map((c, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -6, scale: 1.02 }}
                    transition={{ type: "spring", stiffness: 200 }}
                    className="bg-white p-6 rounded-2xl shadow-lg text-center"
                  >
                    <div className="w-12 h-12 flex items-center justify-center bg-blue-100 text-blue-600 rounded-xl text-2xl mx-auto mb-3">
                      {c.icon}
                    </div>
                    <h3 className="text-lg font-semibold text-gray-800">
                      {c.title}
                    </h3>
                    <p className="text-gray-600 mt-2 text-sm">{c.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* How It Works */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                How It Works
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    step: "1",
                    title: "Define Your Target Profile",
                    desc: "We align demographics, region, certification type & budget range.",
                  },
                  {
                    step: "2",
                    title: "Receive & Review Leads",
                    desc: "Get leads in your dashboard — act within 48 hours.",
                  },
                  {
                    step: "3",
                    title: "Engage & Convert",
                    desc: "Use proven scripts and templates to boost conversions by 30%.",
                  },
                ].map((s, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.15 }}
                    className="bg-white p-6 rounded-2xl shadow-md text-center relative"
                  >
                    <span
                      className="absolute -top-6 left-1/2 transform -translate-x-1/2 
                 w-14 h-14 flex items-center justify-center 
                 bg-blue-600 text-white rounded-full 
                 font-bold text-xl shadow-lg"
                    >
                      {s.step}
                    </span>

                    <h3 className="text-md font-semibold text-gray-900 mt-5">
                      {s.title}
                    </h3>
                    <p className="text-gray-600 mt-1 text-sm">{s.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Pricing */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                Select Your Package
              </h2>

              {/* Billing Toggle */}
              <div className="flex justify-center mb-6">
                <div className="flex space-x-2 bg-gray-100 p-1 rounded-full">
                  {["monthly", "annually"].map((cycle) => (
                    <button
                      key={cycle}
                      onClick={() => setBillingCycle(cycle)}
                      className={`px-3 py-1 text-sm font-medium rounded-full transition ${
                        billingCycle === cycle
                          ? "bg-blue-600 text-white"
                          : "text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      {cycle === "annually" ? "Annually (30% OFF)" : "Monthly"}
                    </button>
                  ))}
                </div>
              </div>

              {/* Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {plans.map((plan, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -6, scale: 1.02 }}
                    className={`bg-white rounded-xl shadow-lg overflow-hidden relative p-5 transition flex flex-col h-full ${
                      plan.popular ? "ring-2 ring-blue-600" : ""
                    }`}
                  >
                    {/* Top content */}
                    <div className="flex-grow">
                      <h3 className="text-lg font-bold">{plan.title}</h3>
                      <p className="text-2xl font-extrabold mt-1">
                        ₹{plan.price}
                        <span className="text-gray-500 text-xs">/month</span>
                      </p>
                      <ul className="mt-4 space-y-2 text-sm text-gray-600">
                        {plan.features.map((f, idx) => (
                          <li key={idx}>✅ {f}</li>
                        ))}
                      </ul>
                    </div>

                    {/* Button fixed at bottom */}
                    <div className="mt-4">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-medium transition text-sm"
                      >
                        Subscribe
                      </motion.button>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Custom Contact */}
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                className="mt-8 text-center"
              >
                <h3 className="text-lg font-semibold text-blue-700">
                  Need something custom?
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Let’s talk about a tailored solution for your organization.
                </p>
                <a
                  href="https://wa.me/919773571992"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-5 rounded-full font-medium transition text-sm"
                >
                  Contact Sales
                </a>
              </motion.div>
            </section>
          </div>
        </div>
        <div
          ref={formRef}
          className="min-h-screen flex items-center justify-center px-4"
        >
          <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden">
            {/* === Form Card Header === */}
            <div className="bg-blue-600 px-6 py-8 text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 bg-white rounded-full mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Register Your Institute
              </h1>
              <p className="text-blue-100">
                Complete your registration in just 2 simple steps
              </p>
            </div>
            <div className="flex justify-center px-8 pt-6">
              <div className="w-full max-w-md">
                <div className="flex items-center">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">
                      1
                    </div>
                    <div className="text-sm font-medium text-blue-600 mt-1">
                      Phone Verification
                    </div>
                  </div>
                  <div className="flex-1 h-1 bg-gray-200 mx-2"></div>
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center font-bold">
                      2
                    </div>
                    <div className="text-sm font-medium text-gray-500 mt-1">
                      Institute Details
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* === Stepper + Form === */}
            <div className="px-6 py-8 sm:px-10 relative">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-gray-800">
                  Verify Your Phone Number
                </h2>
                <p className="text-gray-600 mt-2">
                  We'll send a 4-digit verification code
                </p>
              </div>

              <div className="max-w-md mx-auto space-y-6">
                {/* === Phone Input === */}
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span className="text-gray-500 sm:text-sm">+91</span>
                    </div>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={phoneNumber}
                      onChange={(e) =>
                        setPhoneNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10),
                        )
                      }
                      maxLength="10"
                      className="block w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                      placeholder=""
                      inputMode="numeric"
                    />
                  </div>
                </div>

                {/* === Submit Button === */}
                <div className="pt-2">
                  <button
                    onClick={handlePhoneSubmit}
                    disabled={loading || phoneNumber.length !== 10}
                    className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                      loading || phoneNumber.length !== 10
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    {loading ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Sending OTP...
                      </>
                    ) : (
                      "Send Verification Code"
                    )}
                  </button>
                </div>
              </div>

              {/* === OTP Modal Overlay (inside card) === */}
              {/* === OTP Modal Overlay (inside card, slightly upper) === */}
              {showModal && (
                <div className="absolute inset-0 flex items-start justify-center bg-black/30 backdrop-blur-sm">
                  <div className="-mt- bg-white rounded-xl shadow-xl w-full max-w-sm p-6 relative">
                    <OtpVerify
                      verifyOtp={verifyOtp}
                      resendOtp={resendOtp}
                      onClose={onCloseModal}
                      phoneNumber={phoneNumber}
                      loading={otpLoading}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Full form for verified users
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 space-y-24">
            {/* Hero Section */}
            <motion.section
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="flex flex-col items-center text-center space-y-6"
            >
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                Empower Your <span className="text-blue-600">RPTO Growth</span>{" "}
                with Consistent, High-Quality Student Leads
              </h1>
              <p className="text-lg text-gray-600 max-w-2xl">
                Tap into a powerful nationwide pipeline for reliable,
                pre-qualified leads every month. Claim your first{" "}
                <span className="font-semibold text-blue-700">
                  5 leads free!
                </span>
              </p>
              {/* <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold shadow hover:bg-blue-700 transition"
        >
          🚀 Get Started
        </motion.button> */}
            </motion.section>

            {/* Why Choose Us */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
                Why Choose Our Subscription?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                  {
                    icon: "🎯",
                    title: "Market Expertise & Precision",
                    desc: "We connect you with pre-qualified drone students using advanced targeting algorithms.",
                  },
                  {
                    icon: "📈",
                    title: "Predictable, Scalable Growth",
                    desc: "Stay consistent with monthly leads and scale confidently with demand.",
                  },
                  {
                    icon: "✅",
                    title: "Quality Assurance",
                    desc: "Every lead is verified for genuine interest and basic qualifications.",
                  },
                ].map((c, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -8, scale: 1.02 }}
                    transition={{ type: "spring", stiffness: 200 }}
                    className="bg-white p-8 rounded-2xl shadow-lg text-center"
                  >
                    <div className="w-14 h-14 flex items-center justify-center bg-blue-100 text-blue-600 rounded-xl text-2xl mx-auto mb-4">
                      {c.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      {c.title}
                    </h3>
                    <p className="text-gray-600 mt-3">{c.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* How It Works */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
                How It Works
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                  {
                    step: "1",
                    title: "Define Your Target Profile",
                    desc: "We align demographics, region, certification type & budget range.",
                  },
                  {
                    step: "2",
                    title: "Receive & Review Leads",
                    desc: "Get leads in your dashboard — act within 48 hours.",
                  },
                  {
                    step: "3",
                    title: "Engage & Convert",
                    desc: "Use proven scripts and templates to boost conversions by 30%.",
                  },
                ].map((s, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.2 }}
                    className="bg-white p-8 rounded-2xl shadow-md text-center relative"
                  >
                    <span className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-full font-bold">
                      {s.step}
                    </span>
                    <h3 className="text-lg font-semibold text-gray-900 mt-6">
                      {s.title}
                    </h3>
                    <p className="text-gray-600 mt-2">{s.desc}</p>
                  </motion.div>
                ))}
              </div>
            </section>

            {/* Pricing */}
            <section>
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
                Select Your Package
              </h2>

              {/* Billing Toggle */}
              <div className="flex justify-center mb-10">
                <div className="flex space-x-3 bg-gray-100 p-1 rounded-full">
                  {["monthly", "annually"].map((cycle) => (
                    <button
                      key={cycle}
                      onClick={() => setBillingCycle(cycle)}
                      className={`px-4 py-2 text-sm font-medium rounded-full transition ${
                        billingCycle === cycle
                          ? "bg-blue-600 text-white"
                          : "text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      {cycle === "annually" ? "Annually (30% OFF)" : "Monthly"}
                    </button>
                  ))}
                </div>
              </div>

              {/* Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {plans.map((plan, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -10, scale: 1.03 }}
                    className={`bg-white rounded-xl shadow-lg overflow-hidden relative p-6 transition flex flex-col h-full ${
                      plan.popular ? "ring-2 ring-blue-600" : ""
                    }`}
                  >
                    {/* Most Popular Badge */}

                    {/* Top content */}
                    <div className="flex-grow">
                      <h3 className="text-xl font-bold">{plan.title}</h3>
                      <p className="text-3xl font-extrabold mt-2">
                        ₹{plan.price}
                        <span className="text-gray-500 text-sm">/month</span>
                      </p>
                      <ul className="mt-6 space-y-3 text-sm text-gray-600">
                        {plan.features.map((f, idx) => (
                          <li key={idx}>✅ {f}</li>
                        ))}
                      </ul>
                    </div>

                    {/* Button fixed at bottom */}
                    <div className="mt-6">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-medium transition"
                      >
                        Subscribe
                      </motion.button>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Custom Contact */}
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                className="mt-12 text-center"
              >
                <h3 className="text-xl font-semibold text-blue-700">
                  Need something custom?
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Let’s talk about a tailored solution for your organization or
                  enterprise.
                </p>
                <a
                  href="https://wa.me/919773571992"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full font-medium transition"
                >
                  Contact Sales
                </a>
              </motion.div>
            </section>
          </div>
        </div>

        <div ref={formRef} className="text-center mb-10">
          <h1 className="text-2xl font-bold text-gray-800 mb-3">
            Register Your <span className="text-blue-600">Institute</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join our network of certified educational institutions and offer
            drone training programs to aspiring pilots.
          </p>
        </div>

        <div
          ref={formRef}
          className="bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          {/* Progress Bar */}
          <div className="bg-gray-100 px-6 py-4">
            <div className="flex items-center">
              <div className="flex-1">
                <div className="text-sm font-medium text-gray-700">
                  Registration Progress
                </div>
                <div className="mt-1 flex items-center">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all duration-500"
                      style={{ width: "50%" }}
                    ></div>
                  </div>
                  <span className="ml-4 text-xs font-medium text-gray-600">
                    50%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Contact Information Section */}
              <div className="md:col-span-2">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </span>
                  Contact Information
                </h2>
              </div>

              {/* Name */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="name"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  Your Name <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              {/* Institute Name */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="instituteName"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                  Institute Name <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="instituteName"
                  value={formData.instituteName}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Enter institute name"
                  required
                />
              </div>

              {/* Email */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="email"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  Email <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="institute@example.com"
                  required
                />
              </div>

              {/* Location */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="location"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  Location <span className="text-red-500 ml-1">*</span>
                </label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_KEY}
                  onPlaceSelected={handlePlaceSelected}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  options={{
                    types: ["(cities)"],
                    componentRestrictions: { country: "in" },
                  }}
                  placeholder="Enter your city"
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                />
              </div>

              {/* Institute Information Section */}
              <div className="md:col-span-2 mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      />
                    </svg>
                  </span>
                  Institute Information
                </h2>
              </div>

              {/* Address */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="address"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                  Institute Address <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  onFocus={(e) => handleInputHover(e, true)}
                  onBlur={(e) => handleInputHover(e, false)}
                  placeholder="Enter complete institute address"
                  required
                />
              </div>

              {/* Institute Image */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="instituteImage"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  Institute Image <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    name="instituteImage"
                    onChange={handleImageChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    type="file"
                    accept="image/*"
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                  />
                  {imageSizeValid !== null && (
                    <div
                      className={`absolute inset-y-0 right-0 pr-3 flex items-center`}
                    >
                      {imageSizeValid ? (
                        <svg
                          className="h-5 w-5 text-green-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="h-5 w-5 text-red-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      )}
                    </div>
                  )}
                </div>
                {imageSizeValid !== null && (
                  <p
                    className={`mt-2 text-sm flex items-center ${imageSizeValid ? "text-green-600" : "text-red-600"}`}
                  >
                    <svg
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d={
                          imageSizeValid
                            ? "M5 13l4 4L19 7"
                            : "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        }
                      />
                    </svg>
                    {imageSizeValid
                      ? "Image size is valid"
                      : "Image size should be under 1MB"}
                  </p>
                )}
              </div>

              {/* Security Section */}
              <div className="md:col-span-2 mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-blue-100 text-blue-600 rounded-full p-2 mr-3">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </span>
                  Account Security
                </h2>
              </div>

              {/* Password */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="password"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                  Password <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    className={`w-full px-4 py-3 rounded-lg border ${passwordValidation.isValid ? "border-green-500" : "border-red-500"} focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10`}
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                    placeholder="Create a strong password"
                    required
                  />
                  {passwordValidation.isValid ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <svg
                        className="h-5 w-5 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  ) : (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <svg
                        className="h-5 w-5 text-red-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  )}
                </div>
                {!passwordValidation.isValid && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <svg
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    Password must be at least 6 characters long
                  </p>
                )}
              </div>

              {/* Confirm Password */}
              <div className="form-field">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2 flex items-center"
                  htmlFor="confirmPassword"
                >
                  <svg
                    className="h-4 w-4 text-gray-500 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                  Confirm Password <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                  <input
                    className={`w-full px-4 py-3 rounded-lg border ${passwordValidation.match === true ? "border-green-500" : passwordValidation.match === false ? "border-red-500" : "border-gray-300"} focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10`}
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    onFocus={(e) => handleInputHover(e, true)}
                    onBlur={(e) => handleInputHover(e, false)}
                    placeholder="Confirm your password"
                    required
                  />
                  {passwordValidation.match === true ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <svg
                        className="h-5 w-5 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  ) : passwordValidation.match === false ? (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                      <svg
                        className="h-5 w-5 text-red-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  ) : null}
                </div>
                {passwordValidation.match === false && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <svg
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    Passwords do not match
                  </p>
                )}
                {passwordValidation.match === true && (
                  <p className="mt-2 text-sm text-green-600 flex items-center">
                    <svg
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    Passwords match
                  </p>
                )}
              </div>
            </div>

            {/* Terms and Conditions */}
            <div className="flex items-start mt-8 form-field p-4 bg-blue-50 rounded-lg">
              <div className="flex items-center h-5">
                <input
                  type="checkbox"
                  id="subsidyAcknowledgement"
                  name="subsidyAcknowledgement"
                  checked={checkboxState.subsidyAcknowledgement}
                  onChange={handleCheckboxChange}
                  className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
              </div>
              <div className="ml-3 text-sm">
                <label
                  htmlFor="subsidyAcknowledgement"
                  className="font-medium text-gray-700"
                >
                  I Accept The{" "}
                  <Link
                    to="/terms-and-conditions"
                    className="text-blue-600 hover:text-blue-500 underline font-semibold"
                  >
                    Terms and Conditions
                  </Link>{" "}
                  and acknowledge that I have read the{" "}
                  <Link
                    to="/privacy-policy"
                    className="text-blue-600 hover:text-blue-500 underline font-semibold"
                  >
                    Privacy Policy
                  </Link>
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <button
              onClick={submitHandle}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
              className="w-full mt-6 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-md hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 flex justify-center items-center gap-2"
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" />
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <span>Validate and Proceed to Next</span>
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MultiFormRegistration;
